(() => {
  "use strict";
  var e = {
      195: (e, t, r) => {
        function createIterablePromise({
          func: e,
          validate: t,
          aggregator: r,
          error: a,
          timeout: s = () => 0,
        }) {
          const retry = (i) =>
            new Promise((n, o) => {
              e(i)
                .then(
                  (e) => (
                    r && r(e),
                    t(e)
                      ? n(e)
                      : a && a.validate(e)
                      ? o(new Error(a.message(e)))
                      : setTimeout(() => {
                          retry(e).then(n).catch(o);
                        }, s())
                  )
                )
                .catch((e) => {
                  o(e);
                });
            });
          return retry();
        }
        function createBrowserLocalStorageCache(e) {
          let t;
          const r = `algolia-client-js-${e.key}`;
          function getStorage() {
            return (
              void 0 === t && (t = e.localStorage || window.localStorage), t
            );
          }
          function getNamespace() {
            return JSON.parse(getStorage().getItem(r) || "{}");
          }
          function setNamespace(e) {
            getStorage().setItem(r, JSON.stringify(e));
          }
          return {
            get: (t, r, a = { miss: () => Promise.resolve() }) =>
              Promise.resolve()
                .then(
                  () => (
                    (function removeOutdatedCacheItems() {
                      const t = e.timeToLive ? 1e3 * e.timeToLive : null,
                        r = getNamespace(),
                        a = Object.fromEntries(
                          Object.entries(r).filter(
                            ([, e]) => void 0 !== e.timestamp
                          )
                        );
                      if ((setNamespace(a), !t)) return;
                      setNamespace(
                        Object.fromEntries(
                          Object.entries(a).filter(([, e]) => {
                            const r = new Date().getTime();
                            return !(e.timestamp + t < r);
                          })
                        )
                      );
                    })(),
                    getNamespace()[JSON.stringify(t)]
                  )
                )
                .then((e) => Promise.all([e ? e.value : r(), void 0 !== e]))
                .then(([e, t]) => Promise.all([e, t || a.miss(e)]))
                .then(([e]) => e),
            set: (e, t) =>
              Promise.resolve().then(() => {
                const a = getNamespace();
                return (
                  (a[JSON.stringify(e)] = {
                    timestamp: new Date().getTime(),
                    value: t,
                  }),
                  getStorage().setItem(r, JSON.stringify(a)),
                  t
                );
              }),
            delete: (e) =>
              Promise.resolve().then(() => {
                const t = getNamespace();
                delete t[JSON.stringify(e)],
                  getStorage().setItem(r, JSON.stringify(t));
              }),
            clear: () =>
              Promise.resolve().then(() => {
                getStorage().removeItem(r);
              }),
          };
        }
        function createFallbackableCache(e) {
          const t = [...e.caches],
            r = t.shift();
          return void 0 === r
            ? (function createNullCache() {
                return {
                  get: (e, t, r = { miss: () => Promise.resolve() }) =>
                    t()
                      .then((e) => Promise.all([e, r.miss(e)]))
                      .then(([e]) => e),
                  set: (e, t) => Promise.resolve(t),
                  delete: (e) => Promise.resolve(),
                  clear: () => Promise.resolve(),
                };
              })()
            : {
                get: (e, a, s = { miss: () => Promise.resolve() }) =>
                  r
                    .get(e, a, s)
                    .catch(() =>
                      createFallbackableCache({ caches: t }).get(e, a, s)
                    ),
                set: (e, a) =>
                  r
                    .set(e, a)
                    .catch(() =>
                      createFallbackableCache({ caches: t }).set(e, a)
                    ),
                delete: (e) =>
                  r
                    .delete(e)
                    .catch(() =>
                      createFallbackableCache({ caches: t }).delete(e)
                    ),
                clear: () =>
                  r
                    .clear()
                    .catch(() =>
                      createFallbackableCache({ caches: t }).clear()
                    ),
              };
        }
        function createMemoryCache(e = { serializable: !0 }) {
          let t = {};
          return {
            get(r, a, s = { miss: () => Promise.resolve() }) {
              const i = JSON.stringify(r);
              if (i in t)
                return Promise.resolve(
                  e.serializable ? JSON.parse(t[i]) : t[i]
                );
              const n = a();
              return n.then((e) => s.miss(e)).then(() => n);
            },
            set: (r, a) => (
              (t[JSON.stringify(r)] = e.serializable ? JSON.stringify(a) : a),
              Promise.resolve(a)
            ),
            delete: (e) => (delete t[JSON.stringify(e)], Promise.resolve()),
            clear: () => ((t = {}), Promise.resolve()),
          };
        }
        r.d(t, { AgSearchUtil: () => AgSearchUtil });
        const a = 12e4;
        function createStatefulHost(e, t = "up") {
          const r = Date.now();
          return {
            ...e,
            status: t,
            lastUpdate: r,
            isUp: function isUp() {
              return "up" === t || Date.now() - r > a;
            },
            isTimedOut: function isTimedOut() {
              return "timed out" === t && Date.now() - r <= a;
            },
          };
        }
        function _toPropertyKey(e) {
          var t = (function _toPrimitive(e, t) {
            if ("object" != typeof e || !e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
              var a = r.call(e, t || "default");
              if ("object" != typeof a) return a;
              throw new TypeError(
                "@@toPrimitive must return a primitive value."
              );
            }
            return ("string" === t ? String : Number)(e);
          })(e, "string");
          return "symbol" == typeof t ? t : t + "";
        }
        function _defineProperty(e, t, r) {
          return (
            (t = _toPropertyKey(t)) in e
              ? Object.defineProperty(e, t, {
                  value: r,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (e[t] = r),
            e
          );
        }
        class AlgoliaError extends Error {
          constructor(e, t) {
            super(e),
              _defineProperty(this, "name", "AlgoliaError"),
              t && (this.name = t);
          }
        }
        class ErrorWithStackTrace extends AlgoliaError {
          constructor(e, t, r) {
            super(e, r),
              _defineProperty(this, "stackTrace", void 0),
              (this.stackTrace = t);
          }
        }
        class RetryError extends ErrorWithStackTrace {
          constructor(e) {
            super(
              "Unreachable hosts - your application id may be incorrect. If the error persists, please create a ticket at https://support.algolia.com/ sharing steps we can use to reproduce the issue.",
              e,
              "RetryError"
            );
          }
        }
        class ApiError extends ErrorWithStackTrace {
          constructor(e, t, r, a = "ApiError") {
            super(e, r, a),
              _defineProperty(this, "status", void 0),
              (this.status = t);
          }
        }
        class DeserializationError extends AlgoliaError {
          constructor(e, t) {
            super(e, "DeserializationError"),
              _defineProperty(this, "response", void 0),
              (this.response = t);
          }
        }
        class DetailedApiError extends ApiError {
          constructor(e, t, r, a) {
            super(e, t, a, "DetailedApiError"),
              _defineProperty(this, "error", void 0),
              (this.error = r);
          }
        }
        function serializeUrl(e, t, r) {
          const a = (function serializeQueryParameters(e) {
            const isObjectOrArray = (e) =>
              "[object Object]" === Object.prototype.toString.call(e) ||
              "[object Array]" === Object.prototype.toString.call(e);
            return Object.keys(e)
              .map(
                (t) =>
                  `${t}=${encodeURIComponent(
                    isObjectOrArray(e[t]) ? JSON.stringify(e[t]) : e[t]
                  ).replaceAll("+", "%20")}`
              )
              .join("&");
          })(r);
          let s = `${e.protocol}://${e.url}${e.port ? `:${e.port}` : ""}/${
            "/" === t.charAt(0) ? t.substring(1) : t
          }`;
          return a.length && (s += `?${a}`), s;
        }
        function stackFrameWithoutCredentials(e) {
          const t = e.request.headers["x-algolia-api-key"]
            ? { "x-algolia-api-key": "*****" }
            : {};
          return {
            ...e,
            request: { ...e.request, headers: { ...e.request.headers, ...t } },
          };
        }
        function createTransporter({
          hosts: e,
          hostsCache: t,
          baseHeaders: r,
          baseQueryParameters: a,
          algoliaAgent: s,
          timeouts: i,
          requester: n,
          requestsCache: o,
          responsesCache: c,
        }) {
          async function retryableRequest(o, c, l = !0) {
            const d = [],
              h = (function serializeData(e, t) {
                if (
                  "GET" === e.method ||
                  (void 0 === e.data && void 0 === t.data)
                )
                  return;
                const r = Array.isArray(e.data)
                  ? e.data
                  : { ...e.data, ...t.data };
                return JSON.stringify(r);
              })(o, c),
              u = (function serializeHeaders(e, t, r) {
                const a = { Accept: "application/json", ...e, ...t, ...r },
                  s = {};
                return (
                  Object.keys(a).forEach((e) => {
                    const t = a[e];
                    s[e.toLowerCase()] = t;
                  }),
                  s
                );
              })(r, o.headers, c.headers),
              m = "GET" === o.method ? { ...o.data, ...c.data } : {},
              p = { ...a, ...o.queryParameters, ...m };
            if (
              (s.value && (p["x-algolia-agent"] = s.value),
              c && c.queryParameters)
            )
              for (const e of Object.keys(c.queryParameters))
                c.queryParameters[e] &&
                "[object Object]" !==
                  Object.prototype.toString.call(c.queryParameters[e])
                  ? (p[e] = c.queryParameters[e].toString())
                  : (p[e] = c.queryParameters[e]);
            let b = 0;
            const retry = async (e, r) => {
                const a = e.pop();
                if (void 0 === a)
                  throw new RetryError(
                    (function stackTraceWithoutCredentials(e) {
                      return e.map((e) => stackFrameWithoutCredentials(e));
                    })(d)
                  );
                let s = c.timeout;
                void 0 === s && (s = l ? i.read : i.write);
                const m = {
                    data: h,
                    headers: u,
                    method: o.method,
                    url: serializeUrl(a, o.path, p),
                    connectTimeout: r(b, i.connect),
                    responseTimeout: r(b, s),
                  },
                  pushToStackTrace = (t) => {
                    const r = {
                      request: m,
                      response: t,
                      host: a,
                      triesLeft: e.length,
                    };
                    return d.push(r), r;
                  },
                  y = await n.send(m);
                if (
                  (function isRetryable({ isTimedOut: e, status: t }) {
                    return (
                      e ||
                      (function isNetworkError({ isTimedOut: e, status: t }) {
                        return !e && 0 == ~~t;
                      })({ isTimedOut: e, status: t }) ||
                      (2 != ~~(t / 100) && 4 != ~~(t / 100))
                    );
                  })(y)
                ) {
                  const s = pushToStackTrace(y);
                  return (
                    y.isTimedOut && b++,
                    console.log(
                      "Retryable failure",
                      stackFrameWithoutCredentials(s)
                    ),
                    await t.set(
                      a,
                      createStatefulHost(a, y.isTimedOut ? "timed out" : "down")
                    ),
                    retry(e, r)
                  );
                }
                if (
                  (function isSuccess({ status: e }) {
                    return 2 == ~~(e / 100);
                  })(y)
                )
                  return (function deserializeSuccess(e) {
                    try {
                      return JSON.parse(e.content);
                    } catch (t) {
                      throw new DeserializationError(t.message, e);
                    }
                  })(y);
                throw (
                  (pushToStackTrace(y),
                  (function deserializeFailure({ content: e, status: t }, r) {
                    try {
                      const a = JSON.parse(e);
                      return "error" in a
                        ? new DetailedApiError(a.message, t, a.error, r)
                        : new ApiError(a.message, t, r);
                    } catch (e) {}
                    return new ApiError(e, t, r);
                  })(y, d))
                );
              },
              y = e.filter(
                (e) =>
                  "readWrite" === e.accept ||
                  (l ? "read" === e.accept : "write" === e.accept)
              ),
              g = await (async function createRetryableOptions(e) {
                const r = await Promise.all(
                    e.map((e) =>
                      t.get(e, () => Promise.resolve(createStatefulHost(e)))
                    )
                  ),
                  a = r.filter((e) => e.isUp()),
                  s = r.filter((e) => e.isTimedOut()),
                  i = [...a, ...s];
                return {
                  hosts: i.length > 0 ? i : e,
                  getTimeout: (e, t) =>
                    (0 === s.length && 0 === e ? 1 : s.length + 3 + e) * t,
                };
              })(y);
            return retry([...g.hosts].reverse(), g.getTimeout);
          }
          return {
            hostsCache: t,
            requester: n,
            timeouts: i,
            algoliaAgent: s,
            baseHeaders: r,
            baseQueryParameters: a,
            hosts: e,
            request: function createRequest(e, t = {}) {
              const s = e.useReadTransporter || "GET" === e.method;
              if (!s) return retryableRequest(e, t, s);
              const createRetryableRequest = () => retryableRequest(e, t);
              if (!0 !== (t.cacheable || e.cacheable))
                return createRetryableRequest();
              const i = {
                request: e,
                requestOptions: t,
                transporter: { queryParameters: a, headers: r },
              };
              return c.get(
                i,
                () =>
                  o.get(i, () =>
                    o
                      .set(i, createRetryableRequest())
                      .then(
                        (e) => Promise.all([o.delete(i), e]),
                        (e) => Promise.all([o.delete(i), Promise.reject(e)])
                      )
                      .then(([e, t]) => t)
                  ),
                { miss: (e) => c.set(i, e) }
              );
            },
            requestsCache: o,
            responsesCache: c,
          };
        }
        function getAlgoliaAgent({ algoliaAgents: e, client: t, version: r }) {
          const a = (function createAlgoliaAgent(e) {
            const t = {
              value: `Algolia for JavaScript (${e})`,
              add(e) {
                const r = `; ${e.segment}${
                  void 0 !== e.version ? ` (${e.version})` : ""
                }`;
                return (
                  -1 === t.value.indexOf(r) && (t.value = `${t.value}${r}`), t
                );
              },
            };
            return t;
          })(r).add({ segment: t, version: r });
          return e.forEach((e) => a.add(e)), a;
        }
        const s = "5.0.0-alpha.110";
        function getDefaultHosts(e) {
          return [
            { url: `${e}-dsn.algolia.net`, accept: "read", protocol: "https" },
            { url: `${e}.algolia.net`, accept: "write", protocol: "https" },
          ].concat(
            (function shuffle(e) {
              const t = e;
              for (let r = e.length - 1; r > 0; r--) {
                const a = Math.floor(Math.random() * (r + 1)),
                  s = e[r];
                (t[r] = e[a]), (t[a] = s);
              }
              return t;
            })([
              {
                url: `${e}-1.algolianet.com`,
                accept: "readWrite",
                protocol: "https",
              },
              {
                url: `${e}-2.algolianet.com`,
                accept: "readWrite",
                protocol: "https",
              },
              {
                url: `${e}-3.algolianet.com`,
                accept: "readWrite",
                protocol: "https",
              },
            ])
          );
        }
        function searchClient(e, t, r) {
          if (!e || "string" != typeof e)
            throw new Error("`appId` is missing.");
          if (!t || "string" != typeof t)
            throw new Error("`apiKey` is missing.");
          return (function createSearchClient({
            appId: e,
            apiKey: t,
            authMode: r,
            algoliaAgents: a,
            ...i
          }) {
            const n = (function createAuth(e, t, r = "WithinHeaders") {
                const a = {
                  "x-algolia-api-key": t,
                  "x-algolia-application-id": e,
                };
                return {
                  headers: () => ("WithinHeaders" === r ? a : {}),
                  queryParameters: () =>
                    "WithinQueryParameters" === r ? a : {},
                };
              })(e, t, r),
              o = createTransporter({
                hosts: getDefaultHosts(e),
                ...i,
                algoliaAgent: getAlgoliaAgent({
                  algoliaAgents: a,
                  client: "Search",
                  version: s,
                }),
                baseHeaders: {
                  "content-type": "text/plain",
                  ...n.headers(),
                  ...i.baseHeaders,
                },
                baseQueryParameters: {
                  ...n.queryParameters(),
                  ...i.baseQueryParameters,
                },
              });
            return {
              transporter: o,
              appId: e,
              clearCache: () =>
                Promise.all([
                  o.requestsCache.clear(),
                  o.responsesCache.clear(),
                ]).then(() => {}),
              get _ua() {
                return o.algoliaAgent.value;
              },
              addAlgoliaAgent(e, t) {
                o.algoliaAgent.add({ segment: e, version: t });
              },
              waitForTask(
                {
                  indexName: e,
                  taskID: t,
                  maxRetries: r = 50,
                  timeout: a = (e) => Math.min(200 * e, 5e3),
                },
                s
              ) {
                let i = 0;
                return createIterablePromise({
                  func: () => this.getTask({ indexName: e, taskID: t }, s),
                  validate: (e) => "published" === e.status,
                  aggregator: () => (i += 1),
                  error: {
                    validate: () => i >= r,
                    message: () =>
                      `The maximum number of retries exceeded. (${i}/${r})`,
                  },
                  timeout: () => a(i),
                });
              },
              waitForApiKey(
                {
                  operation: e,
                  key: t,
                  apiKey: r,
                  maxRetries: a = 50,
                  timeout: s = (e) => Math.min(200 * e, 5e3),
                },
                i
              ) {
                let n = 0;
                const o = {
                  aggregator: () => (n += 1),
                  error: {
                    validate: () => n >= a,
                    message: () =>
                      `The maximum number of retries exceeded. (${n}/${a})`,
                  },
                  timeout: () => s(n),
                };
                if ("update" === e) {
                  if (!r)
                    throw new Error(
                      "`apiKey` is required when waiting for an `update` operation."
                    );
                  return createIterablePromise({
                    ...o,
                    func: () => this.getApiKey({ key: t }, i),
                    validate: (e) => {
                      for (const t of Object.keys(r)) {
                        const a = r[t],
                          s = e[t];
                        if (Array.isArray(a) && Array.isArray(s)) {
                          if (
                            a.length !== s.length ||
                            a.some((e, t) => e !== s[t])
                          )
                            return !1;
                        } else if (a !== s) return !1;
                      }
                      return !0;
                    },
                  });
                }
                return createIterablePromise({
                  ...o,
                  func: () => this.getApiKey({ key: t }, i).catch((e) => e),
                  validate: (t) =>
                    "add" === e ? 404 !== t.status : 404 === t.status,
                });
              },
              browseObjects({ indexName: e, browseParams: t, ...r }, a) {
                return createIterablePromise({
                  func: (r) =>
                    this.browse(
                      {
                        indexName: e,
                        browseParams: { cursor: r ? r.cursor : void 0, ...t },
                      },
                      a
                    ),
                  validate: (e) => void 0 === e.cursor,
                  ...r,
                });
              },
              browseRules({ indexName: e, searchRulesParams: t, ...r }, a) {
                const s = { hitsPerPage: 1e3, ...t };
                return createIterablePromise({
                  func: (t) =>
                    this.searchRules(
                      {
                        indexName: e,
                        searchRulesParams: {
                          ...s,
                          page: t ? t.page + 1 : s.page || 0,
                        },
                      },
                      a
                    ),
                  validate: (e) => e.nbHits < s.hitsPerPage,
                  ...r,
                });
              },
              browseSynonyms(
                { indexName: e, searchSynonymsParams: t, ...r },
                a
              ) {
                const s = { page: 0, ...t, hitsPerPage: 1e3 };
                return createIterablePromise({
                  func: (t) => {
                    const r = this.searchSynonyms(
                      {
                        indexName: e,
                        searchSynonymsParams: { ...s, page: s.page },
                      },
                      a
                    );
                    return (s.page += 1), r;
                  },
                  validate: (e) => e.nbHits < s.hitsPerPage,
                  ...r,
                });
              },
              searchForHits(e, t) {
                return this.search(e, t);
              },
              searchForFacets(e, t) {
                return this.search(e, t);
              },
              async chunkedBatch(
                {
                  indexName: e,
                  objects: t,
                  action: r = "addObject",
                  waitForTasks: a,
                  batchSize: s = 1e3,
                },
                i
              ) {
                let n = [];
                const o = [];
                for (const [a, c] of t.entries())
                  n.push({ action: r, body: c }),
                    a % s == 0 &&
                      (o.push(
                        await this.batch(
                          { indexName: e, batchWriteParams: { requests: n } },
                          i
                        )
                      ),
                      (n = []));
                if (a)
                  for (const t of o)
                    await this.waitForTask({ indexName: e, taskID: t.taskID });
                return o;
              },
              async replaceAllObjects(
                { indexName: e, objects: t, batchSize: r },
                a
              ) {
                const s = `${e}_tmp_${Math.random().toString(36).substring(7)}`,
                  i = await this.operationIndex(
                    {
                      indexName: e,
                      operationIndexParams: {
                        operation: "copy",
                        destination: s,
                        scope: ["settings", "rules", "synonyms"],
                      },
                    },
                    a
                  );
                await this.waitForTask({ indexName: e, taskID: i.taskID });
                const n = await this.chunkedBatch(
                    {
                      indexName: s,
                      objects: t,
                      waitForTasks: !0,
                      batchSize: r,
                    },
                    a
                  ),
                  o = await this.operationIndex(
                    {
                      indexName: s,
                      operationIndexParams: {
                        operation: "move",
                        destination: e,
                      },
                    },
                    a
                  );
                return (
                  await this.waitForTask({ indexName: e, taskID: o.taskID }),
                  {
                    copyOperationResponse: i,
                    batchResponses: n,
                    moveOperationResponse: o,
                  }
                );
              },
              addApiKey(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `apiKey` is required when calling `addApiKey`."
                  );
                if (!e.acl)
                  throw new Error(
                    "Parameter `apiKey.acl` is required when calling `addApiKey`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/keys",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              addOrUpdateObject({ indexName: e, objectID: t, body: r }, a) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `addOrUpdateObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `addOrUpdateObject`."
                  );
                if (!r)
                  throw new Error(
                    "Parameter `body` is required when calling `addOrUpdateObject`."
                  );
                const s = {
                  method: "PUT",
                  path: "/1/indexes/{indexName}/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                  data: r,
                };
                return o.request(s, a);
              },
              appendSource(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `source` is required when calling `appendSource`."
                  );
                if (!e.source)
                  throw new Error(
                    "Parameter `source.source` is required when calling `appendSource`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/security/sources/append",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              assignUserId({ xAlgoliaUserID: e, assignUserIdParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `xAlgoliaUserID` is required when calling `assignUserId`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `assignUserIdParams` is required when calling `assignUserId`."
                  );
                if (!t.cluster)
                  throw new Error(
                    "Parameter `assignUserIdParams.cluster` is required when calling `assignUserId`."
                  );
                const a = {};
                void 0 !== e && (a["X-Algolia-User-ID"] = e.toString());
                const s = {
                  method: "POST",
                  path: "/1/clusters/mapping",
                  queryParameters: {},
                  headers: a,
                  data: t,
                };
                return o.request(s, r);
              },
              batch({ indexName: e, batchWriteParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `batch`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `batchWriteParams` is required when calling `batch`."
                  );
                if (!t.requests)
                  throw new Error(
                    "Parameter `batchWriteParams.requests` is required when calling `batch`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/batch".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(a, r);
              },
              batchAssignUserIds(
                { xAlgoliaUserID: e, batchAssignUserIdsParams: t },
                r
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `xAlgoliaUserID` is required when calling `batchAssignUserIds`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `batchAssignUserIdsParams` is required when calling `batchAssignUserIds`."
                  );
                if (!t.cluster)
                  throw new Error(
                    "Parameter `batchAssignUserIdsParams.cluster` is required when calling `batchAssignUserIds`."
                  );
                if (!t.users)
                  throw new Error(
                    "Parameter `batchAssignUserIdsParams.users` is required when calling `batchAssignUserIds`."
                  );
                const a = {};
                void 0 !== e && (a["X-Algolia-User-ID"] = e.toString());
                const s = {
                  method: "POST",
                  path: "/1/clusters/mapping/batch",
                  queryParameters: {},
                  headers: a,
                  data: t,
                };
                return o.request(s, r);
              },
              batchDictionaryEntries(
                { dictionaryName: e, batchDictionaryEntriesParams: t },
                r
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `dictionaryName` is required when calling `batchDictionaryEntries`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `batchDictionaryEntriesParams` is required when calling `batchDictionaryEntries`."
                  );
                if (!t.requests)
                  throw new Error(
                    "Parameter `batchDictionaryEntriesParams.requests` is required when calling `batchDictionaryEntries`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/dictionaries/{dictionaryName}/batch".replace(
                    "{dictionaryName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(a, r);
              },
              browse({ indexName: e, browseParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `browse`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/browse".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t || {},
                };
                return o.request(a, r);
              },
              clearObjects({ indexName: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `clearObjects`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/clear".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              clearRules({ indexName: e, forwardToReplicas: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `clearRules`."
                  );
                const a = "/1/indexes/{indexName}/rules/clear".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  s = {};
                void 0 !== t && (s.forwardToReplicas = t.toString());
                const i = {
                  method: "POST",
                  path: a,
                  queryParameters: s,
                  headers: {},
                };
                return o.request(i, r);
              },
              clearSynonyms({ indexName: e, forwardToReplicas: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `clearSynonyms`."
                  );
                const a = "/1/indexes/{indexName}/synonyms/clear".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  s = {};
                void 0 !== t && (s.forwardToReplicas = t.toString());
                const i = {
                  method: "POST",
                  path: a,
                  queryParameters: s,
                  headers: {},
                };
                return o.request(i, r);
              },
              customDelete({ path: e, parameters: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `path` is required when calling `customDelete`."
                  );
                const a = {
                  method: "DELETE",
                  path: "/{path}".replace("{path}", e),
                  queryParameters: t || {},
                  headers: {},
                };
                return o.request(a, r);
              },
              customGet({ path: e, parameters: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `path` is required when calling `customGet`."
                  );
                const a = {
                  method: "GET",
                  path: "/{path}".replace("{path}", e),
                  queryParameters: t || {},
                  headers: {},
                };
                return o.request(a, r);
              },
              customPost({ path: e, parameters: t, body: r }, a) {
                if (!e)
                  throw new Error(
                    "Parameter `path` is required when calling `customPost`."
                  );
                const s = {
                  method: "POST",
                  path: "/{path}".replace("{path}", e),
                  queryParameters: t || {},
                  headers: {},
                  data: r || {},
                };
                return o.request(s, a);
              },
              customPut({ path: e, parameters: t, body: r }, a) {
                if (!e)
                  throw new Error(
                    "Parameter `path` is required when calling `customPut`."
                  );
                const s = {
                  method: "PUT",
                  path: "/{path}".replace("{path}", e),
                  queryParameters: t || {},
                  headers: {},
                  data: r || {},
                };
                return o.request(s, a);
              },
              deleteApiKey({ key: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `key` is required when calling `deleteApiKey`."
                  );
                const r = {
                  method: "DELETE",
                  path: "/1/keys/{key}".replace("{key}", encodeURIComponent(e)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              deleteBy({ indexName: e, deleteByParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteBy`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `deleteByParams` is required when calling `deleteBy`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/deleteByQuery".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(a, r);
              },
              deleteIndex({ indexName: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteIndex`."
                  );
                const r = {
                  method: "DELETE",
                  path: "/1/indexes/{indexName}".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              deleteObject({ indexName: e, objectID: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `deleteObject`."
                  );
                const a = {
                  method: "DELETE",
                  path: "/1/indexes/{indexName}/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(a, r);
              },
              deleteRule(
                { indexName: e, objectID: t, forwardToReplicas: r },
                a
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteRule`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `deleteRule`."
                  );
                const s = "/1/indexes/{indexName}/rules/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  i = {};
                void 0 !== r && (i.forwardToReplicas = r.toString());
                const n = {
                  method: "DELETE",
                  path: s,
                  queryParameters: i,
                  headers: {},
                };
                return o.request(n, a);
              },
              deleteSource({ source: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `source` is required when calling `deleteSource`."
                  );
                const r = {
                  method: "DELETE",
                  path: "/1/security/sources/{source}".replace(
                    "{source}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              deleteSynonym(
                { indexName: e, objectID: t, forwardToReplicas: r },
                a
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `deleteSynonym`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `deleteSynonym`."
                  );
                const s = "/1/indexes/{indexName}/synonyms/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  i = {};
                void 0 !== r && (i.forwardToReplicas = r.toString());
                const n = {
                  method: "DELETE",
                  path: s,
                  queryParameters: i,
                  headers: {},
                };
                return o.request(n, a);
              },
              getApiKey({ key: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `key` is required when calling `getApiKey`."
                  );
                const r = {
                  method: "GET",
                  path: "/1/keys/{key}".replace("{key}", encodeURIComponent(e)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              getDictionaryLanguages(e) {
                const t = {
                  method: "GET",
                  path: "/1/dictionaries/*/languages",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              getDictionarySettings(e) {
                const t = {
                  method: "GET",
                  path: "/1/dictionaries/*/settings",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              getLogs(
                { offset: e, length: t, indexName: r, type: a } = {},
                s = void 0
              ) {
                const i = {};
                void 0 !== e && (i.offset = e.toString()),
                  void 0 !== t && (i.length = t.toString()),
                  void 0 !== r && (i.indexName = r.toString()),
                  void 0 !== a && (i.type = a.toString());
                const n = {
                  method: "GET",
                  path: "/1/logs",
                  queryParameters: i,
                  headers: {},
                };
                return o.request(n, s);
              },
              getObject(
                { indexName: e, objectID: t, attributesToRetrieve: r },
                a
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `getObject`."
                  );
                const s = "/1/indexes/{indexName}/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  i = {};
                void 0 !== r && (i.attributesToRetrieve = r.toString());
                const n = {
                  method: "GET",
                  path: s,
                  queryParameters: i,
                  headers: {},
                };
                return o.request(n, a);
              },
              getObjects(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `getObjectsParams` is required when calling `getObjects`."
                  );
                if (!e.requests)
                  throw new Error(
                    "Parameter `getObjectsParams.requests` is required when calling `getObjects`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/indexes/*/objects",
                  queryParameters: {},
                  headers: {},
                  data: e,
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(r, t);
              },
              getRule({ indexName: e, objectID: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getRule`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `getRule`."
                  );
                const a = {
                  method: "GET",
                  path: "/1/indexes/{indexName}/rules/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(a, r);
              },
              getSettings({ indexName: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getSettings`."
                  );
                const r = {
                  method: "GET",
                  path: "/1/indexes/{indexName}/settings".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              getSources(e) {
                const t = {
                  method: "GET",
                  path: "/1/security/sources",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              getSynonym({ indexName: e, objectID: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getSynonym`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `getSynonym`."
                  );
                const a = {
                  method: "GET",
                  path: "/1/indexes/{indexName}/synonyms/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(a, r);
              },
              getTask({ indexName: e, taskID: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `getTask`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `taskID` is required when calling `getTask`."
                  );
                const a = {
                  method: "GET",
                  path: "/1/indexes/{indexName}/task/{taskID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{taskID}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(a, r);
              },
              getTopUserIds(e) {
                const t = {
                  method: "GET",
                  path: "/1/clusters/mapping/top",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              getUserId({ userID: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `userID` is required when calling `getUserId`."
                  );
                const r = {
                  method: "GET",
                  path: "/1/clusters/mapping/{userID}".replace(
                    "{userID}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              hasPendingMappings({ getClusters: e } = {}, t = void 0) {
                const r = {};
                void 0 !== e && (r.getClusters = e.toString());
                const a = {
                  method: "GET",
                  path: "/1/clusters/mapping/pending",
                  queryParameters: r,
                  headers: {},
                };
                return o.request(a, t);
              },
              listApiKeys(e) {
                const t = {
                  method: "GET",
                  path: "/1/keys",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              listClusters(e) {
                const t = {
                  method: "GET",
                  path: "/1/clusters",
                  queryParameters: {},
                  headers: {},
                };
                return o.request(t, e);
              },
              listIndices({ page: e, hitsPerPage: t } = {}, r = void 0) {
                const a = {};
                void 0 !== e && (a.page = e.toString()),
                  void 0 !== t && (a.hitsPerPage = t.toString());
                const s = {
                  method: "GET",
                  path: "/1/indexes",
                  queryParameters: a,
                  headers: {},
                };
                return o.request(s, r);
              },
              listUserIds({ page: e, hitsPerPage: t } = {}, r = void 0) {
                const a = {};
                void 0 !== e && (a.page = e.toString()),
                  void 0 !== t && (a.hitsPerPage = t.toString());
                const s = {
                  method: "GET",
                  path: "/1/clusters/mapping",
                  queryParameters: a,
                  headers: {},
                };
                return o.request(s, r);
              },
              multipleBatch(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `batchParams` is required when calling `multipleBatch`."
                  );
                if (!e.requests)
                  throw new Error(
                    "Parameter `batchParams.requests` is required when calling `multipleBatch`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/indexes/*/batch",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              operationIndex({ indexName: e, operationIndexParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `operationIndex`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `operationIndexParams` is required when calling `operationIndex`."
                  );
                if (!t.operation)
                  throw new Error(
                    "Parameter `operationIndexParams.operation` is required when calling `operationIndex`."
                  );
                if (!t.destination)
                  throw new Error(
                    "Parameter `operationIndexParams.destination` is required when calling `operationIndex`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/operation".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(a, r);
              },
              partialUpdateObject(
                {
                  indexName: e,
                  objectID: t,
                  attributesToUpdate: r,
                  createIfNotExists: a,
                },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `partialUpdateObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `partialUpdateObject`."
                  );
                if (!r)
                  throw new Error(
                    "Parameter `attributesToUpdate` is required when calling `partialUpdateObject`."
                  );
                const i = "/1/indexes/{indexName}/{objectID}/partial"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  n = {};
                void 0 !== a && (n.createIfNotExists = a.toString());
                const c = {
                  method: "POST",
                  path: i,
                  queryParameters: n,
                  headers: {},
                  data: r,
                };
                return o.request(c, s);
              },
              removeUserId({ userID: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `userID` is required when calling `removeUserId`."
                  );
                const r = {
                  method: "DELETE",
                  path: "/1/clusters/mapping/{userID}".replace(
                    "{userID}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              replaceSources({ source: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `source` is required when calling `replaceSources`."
                  );
                const r = {
                  method: "PUT",
                  path: "/1/security/sources",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              restoreApiKey({ key: e }, t) {
                if (!e)
                  throw new Error(
                    "Parameter `key` is required when calling `restoreApiKey`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/keys/{key}/restore".replace(
                    "{key}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                };
                return o.request(r, t);
              },
              saveObject({ indexName: e, body: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveObject`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `body` is required when calling `saveObject`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/indexes/{indexName}".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(a, r);
              },
              saveRule(
                { indexName: e, objectID: t, rule: r, forwardToReplicas: a },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveRule`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `saveRule`."
                  );
                if (!r)
                  throw new Error(
                    "Parameter `rule` is required when calling `saveRule`."
                  );
                if (!r.objectID)
                  throw new Error(
                    "Parameter `rule.objectID` is required when calling `saveRule`."
                  );
                const i = "/1/indexes/{indexName}/rules/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  n = {};
                void 0 !== a && (n.forwardToReplicas = a.toString());
                const c = {
                  method: "PUT",
                  path: i,
                  queryParameters: n,
                  headers: {},
                  data: r,
                };
                return o.request(c, s);
              },
              saveRules(
                {
                  indexName: e,
                  rules: t,
                  forwardToReplicas: r,
                  clearExistingRules: a,
                },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveRules`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `rules` is required when calling `saveRules`."
                  );
                const i = "/1/indexes/{indexName}/rules/batch".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  n = {};
                void 0 !== r && (n.forwardToReplicas = r.toString()),
                  void 0 !== a && (n.clearExistingRules = a.toString());
                const c = {
                  method: "POST",
                  path: i,
                  queryParameters: n,
                  headers: {},
                  data: t,
                };
                return o.request(c, s);
              },
              saveSynonym(
                {
                  indexName: e,
                  objectID: t,
                  synonymHit: r,
                  forwardToReplicas: a,
                },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveSynonym`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `objectID` is required when calling `saveSynonym`."
                  );
                if (!r)
                  throw new Error(
                    "Parameter `synonymHit` is required when calling `saveSynonym`."
                  );
                if (!r.objectID)
                  throw new Error(
                    "Parameter `synonymHit.objectID` is required when calling `saveSynonym`."
                  );
                if (!r.type)
                  throw new Error(
                    "Parameter `synonymHit.type` is required when calling `saveSynonym`."
                  );
                const i = "/1/indexes/{indexName}/synonyms/{objectID}"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{objectID}", encodeURIComponent(t)),
                  n = {};
                void 0 !== a && (n.forwardToReplicas = a.toString());
                const c = {
                  method: "PUT",
                  path: i,
                  queryParameters: n,
                  headers: {},
                  data: r,
                };
                return o.request(c, s);
              },
              saveSynonyms(
                {
                  indexName: e,
                  synonymHit: t,
                  forwardToReplicas: r,
                  replaceExistingSynonyms: a,
                },
                s
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `saveSynonyms`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `synonymHit` is required when calling `saveSynonyms`."
                  );
                const i = "/1/indexes/{indexName}/synonyms/batch".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  n = {};
                void 0 !== r && (n.forwardToReplicas = r.toString()),
                  void 0 !== a && (n.replaceExistingSynonyms = a.toString());
                const c = {
                  method: "POST",
                  path: i,
                  queryParameters: n,
                  headers: {},
                  data: t,
                };
                return o.request(c, s);
              },
              search(e, t) {
                if (e && Array.isArray(e)) {
                  const t = {
                    requests: e.map(({ params: e, ...t }) =>
                      "facet" === t.type
                        ? { ...t, ...e, type: "facet" }
                        : {
                            ...t,
                            ...e,
                            facet: void 0,
                            maxFacetHits: void 0,
                            facetQuery: void 0,
                          }
                    ),
                  };
                  e = t;
                }
                if (!e)
                  throw new Error(
                    "Parameter `searchMethodParams` is required when calling `search`."
                  );
                if (!e.requests)
                  throw new Error(
                    "Parameter `searchMethodParams.requests` is required when calling `search`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/indexes/*/queries",
                  queryParameters: {},
                  headers: {},
                  data: e,
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(r, t);
              },
              searchDictionaryEntries(
                { dictionaryName: e, searchDictionaryEntriesParams: t },
                r
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `dictionaryName` is required when calling `searchDictionaryEntries`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `searchDictionaryEntriesParams` is required when calling `searchDictionaryEntries`."
                  );
                if (!t.query)
                  throw new Error(
                    "Parameter `searchDictionaryEntriesParams.query` is required when calling `searchDictionaryEntries`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/dictionaries/{dictionaryName}/search".replace(
                    "{dictionaryName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t,
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(a, r);
              },
              searchForFacetValues(
                { indexName: e, facetName: t, searchForFacetValuesRequest: r },
                a
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `searchForFacetValues`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `facetName` is required when calling `searchForFacetValues`."
                  );
                const s = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/facets/{facetName}/query"
                    .replace("{indexName}", encodeURIComponent(e))
                    .replace("{facetName}", encodeURIComponent(t)),
                  queryParameters: {},
                  headers: {},
                  data: r || {},
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(s, a);
              },
              searchRules({ indexName: e, searchRulesParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `searchRules`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/rules/search".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t || {},
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(a, r);
              },
              searchSingleIndex({ indexName: e, searchParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `searchSingleIndex`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/query".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t || {},
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(a, r);
              },
              searchSynonyms({ indexName: e, searchSynonymsParams: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `searchSynonyms`."
                  );
                const a = {
                  method: "POST",
                  path: "/1/indexes/{indexName}/synonyms/search".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  queryParameters: {},
                  headers: {},
                  data: t || {},
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(a, r);
              },
              searchUserIds(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `searchUserIdsParams` is required when calling `searchUserIds`."
                  );
                if (!e.query)
                  throw new Error(
                    "Parameter `searchUserIdsParams.query` is required when calling `searchUserIds`."
                  );
                const r = {
                  method: "POST",
                  path: "/1/clusters/mapping/search",
                  queryParameters: {},
                  headers: {},
                  data: e,
                  useReadTransporter: !0,
                  cacheable: !0,
                };
                return o.request(r, t);
              },
              setDictionarySettings(e, t) {
                if (!e)
                  throw new Error(
                    "Parameter `dictionarySettingsParams` is required when calling `setDictionarySettings`."
                  );
                if (!e.disableStandardEntries)
                  throw new Error(
                    "Parameter `dictionarySettingsParams.disableStandardEntries` is required when calling `setDictionarySettings`."
                  );
                const r = {
                  method: "PUT",
                  path: "/1/dictionaries/*/settings",
                  queryParameters: {},
                  headers: {},
                  data: e,
                };
                return o.request(r, t);
              },
              setSettings(
                { indexName: e, indexSettings: t, forwardToReplicas: r },
                a
              ) {
                if (!e)
                  throw new Error(
                    "Parameter `indexName` is required when calling `setSettings`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `indexSettings` is required when calling `setSettings`."
                  );
                const s = "/1/indexes/{indexName}/settings".replace(
                    "{indexName}",
                    encodeURIComponent(e)
                  ),
                  i = {};
                void 0 !== r && (i.forwardToReplicas = r.toString());
                const n = {
                  method: "PUT",
                  path: s,
                  queryParameters: i,
                  headers: {},
                  data: t,
                };
                return o.request(n, a);
              },
              updateApiKey({ key: e, apiKey: t }, r) {
                if (!e)
                  throw new Error(
                    "Parameter `key` is required when calling `updateApiKey`."
                  );
                if (!t)
                  throw new Error(
                    "Parameter `apiKey` is required when calling `updateApiKey`."
                  );
                if (!t.acl)
                  throw new Error(
                    "Parameter `apiKey.acl` is required when calling `updateApiKey`."
                  );
                const a = {
                  method: "PUT",
                  path: "/1/keys/{key}".replace("{key}", encodeURIComponent(e)),
                  queryParameters: {},
                  headers: {},
                  data: t,
                };
                return o.request(a, r);
              },
            };
          })({
            appId: e,
            apiKey: t,
            timeouts: { connect: 1e3, read: 2e3, write: 3e4 },
            requester: {
              send: function send(e) {
                return new Promise((t) => {
                  const r = new XMLHttpRequest();
                  r.open(e.method, e.url, !0),
                    Object.keys(e.headers).forEach((t) =>
                      r.setRequestHeader(t, e.headers[t])
                    );
                  const createTimeout = (e, a) =>
                      setTimeout(() => {
                        r.abort(), t({ status: 0, content: a, isTimedOut: !0 });
                      }, e),
                    a = createTimeout(e.connectTimeout, "Connection timeout");
                  let s;
                  (r.onreadystatechange = () => {
                    r.readyState > r.OPENED &&
                      void 0 === s &&
                      (clearTimeout(a),
                      (s = createTimeout(e.responseTimeout, "Socket timeout")));
                  }),
                    (r.onerror = () => {
                      0 === r.status &&
                        (clearTimeout(a),
                        clearTimeout(s),
                        t({
                          content: r.responseText || "Network request failed",
                          status: r.status,
                          isTimedOut: !1,
                        }));
                    }),
                    (r.onload = () => {
                      clearTimeout(a),
                        clearTimeout(s),
                        t({
                          content: r.responseText,
                          status: r.status,
                          isTimedOut: !1,
                        });
                    }),
                    r.send(e.data);
                });
              },
            },
            algoliaAgents: [{ segment: "Browser" }],
            authMode: "WithinQueryParameters",
            responsesCache: createMemoryCache(),
            requestsCache: createMemoryCache({ serializable: !1 }),
            hostsCache: createFallbackableCache({
              caches: [
                createBrowserLocalStorageCache({ key: `${s}-${e}` }),
                createMemoryCache(),
              ],
            }),
            ...r,
          });
        }
        class AgSearchUtil {
          constructor(e) {
            (this.settings = e),
              (this.client = searchClient(
                this.settings.app_id,
                this.settings.search_api_key
              ));
          }
          search({ query: e, indexes: t, merge: r }) {
            return new Promise((a, s) => {
              (t?.length && e) || s({ error: "no terms or indexes" }),
                this.client
                  .search({
                    requests: t.map(
                      ({
                        indexName: t,
                        hitsPerPage: r,
                        facets: a,
                        facetFilters: s,
                        attributesToRetrieve: i,
                      }) => ({
                        indexName: t,
                        query: e,
                        hitsPerPage: (r = r || 10),
                        facets: (a = a || ["*"]),
                        facetFilters: s,
                        attributesToRetrieve: (i = i || ["*"]),
                      })
                    ),
                  })
                  .then(({ results: e }) => {
                    if (
                      ((e = e.reduce(
                        (e, r) => (
                          (e[
                            t.find(({ indexName: e }) => e == r.index)?.key ||
                              r.index
                          ] = r),
                          e
                        ),
                        {}
                      )),
                      r)
                    ) {
                      const t = r.indexes.map((t) => e[t].hits).flat(1);
                      (r.hits = t),
                        (r.merge = !0),
                        (r.datasets = r.indexes.map((t) => e[t]).flat(1)),
                        r.indexes.forEach((t) => delete e[t]),
                        (e[r.key] = r);
                    }
                    a(e);
                  })
                  .catch((e) => {
                    s({ error: e });
                  });
            });
          }
        }
      },
    },
    t = {};
  function __webpack_require__(r) {
    var a = t[r];
    if (void 0 !== a) return a.exports;
    var s = (t[r] = { exports: {} });
    return e[r](s, s.exports, __webpack_require__), s.exports;
  }
  (__webpack_require__.d = (e, t) => {
    for (var r in t)
      __webpack_require__.o(t, r) &&
        !__webpack_require__.o(e, r) &&
        Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
  }),
    (__webpack_require__.o = (e, t) =>
      Object.prototype.hasOwnProperty.call(e, t)),
    (__webpack_require__.r = (e) => {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    });
  var r = {};
  (() => {
    __webpack_require__.r(r),
      __webpack_require__.d(r, {
        AlgoliaSearchHeader: () => AlgoliaSearchHeader,
        DomReadyPromise: () => DomReadyPromise,
        DynamicImporter: () => DynamicImporter,
        GlobalQtySelector: () => GlobalQtySelector,
        GlobalSidebar: () => GlobalSidebar,
        GlobalSidebarCartUI: () => GlobalSidebarCartUI,
        GlobalVariantQtyHelper: () => GlobalVariantQtyHelper,
        ModalBox: () => ModalBox,
        NiceScroll: () => NiceScroll,
        TrapFocusLite: () => TrapFocusLite,
        customerPrivacyApi: () => customerPrivacyApi,
        klaviyoSubscribe: () => klaviyoSubscribe,
      });
    class ObserverLite {
      constructor(e) {
        if (
          ((e = e || {}),
          (this.id = Math.floor(999999999999 * Math.random())),
          (this.settings = e),
          e.key)
        ) {
          if (
            ((window.GlobalObersverLiteInstances =
              window.GlobalObersverLiteInstances || {}),
            window.GlobalObersverLiteInstances[e.key])
          )
            return window.GlobalObersverLiteInstances[e.key];
          window.GlobalObersverLiteInstances[e.key] = this;
        }
      }
      once() {
        return new Promise((e, t) => {
          this.onceDone && e(this.onceDone);
          const r = this.subscribe((t) => {
            (t = t || !0), (this.onceDone = t), e(t), this.unsubscribe(r);
          });
        });
      }
      setOnce(e) {
        (e = e || !0), (this.onceDone = e);
      }
      next(...e) {
        this.onceDone || this.setOnce(...e),
          this.subject &&
            this.subject.length &&
            this.subject.forEach(({ callback: t }) => {
              t(...e);
            });
      }
      subscribe(e) {
        return (
          (this.subject = this.subject || []),
          (e = { callback: e, id: Math.floor(1e14 + 9e14 * Math.random()) }),
          this.subject.push(e),
          e
        );
      }
      unsubscribe(e) {
        this.subject = this.subject.filter(({ id: t }) => t !== e.id);
      }
      unsubscribeAll(e) {
        this.subject?.forEach((e) => this.unsubscribe(e)),
          e && (this.onceDone = !1);
      }
    }
    function parseHTML(e) {
      const t = document.createElement("template");
      return (t.innerHTML = e), t.content;
    }
    class TrapFocusLite {
      constructor(e) {
        (this.ObserverLite = new ObserverLite()),
          (this.element = e),
          this.element.addEventListener("keydown", (e) => {
            this.keyDownHandler(e);
          });
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      setAttributes(e, t) {
        for (let r in t) e.setAttribute(r, t[r]);
      }
      removeAttributes(e, t) {
        t.forEach((t) => {
          e.removeAttribute(t);
        });
      }
      get focusables() {
        return this.element.querySelectorAll(
          'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
        );
      }
      setFocus() {
        (this.lastFocusedElement = document.activeElement),
          this.focusables[0].focus();
      }
      resetFocus() {
        this.lastFocusedElement.focus();
      }
      keyDownHandler(e) {
        const t = this.focusables,
          r = t[0],
          a = t[t.length - 1];
        "Tab" === e.key || 9 === e.keyCode
          ? e.shiftKey
            ? document.activeElement === r && (e.preventDefault(), a.focus())
            : document.activeElement === a && (e.preventDefault(), r.focus())
          : this.next({ key: e.key });
      }
    }
    class GlobalSidebar extends HTMLElement {
      constructor() {
        super(), (this.ObserverLite = new ObserverLite());
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        const e = this.querySelector(":scope > template");
        (this.content = e?.children[0] || e?.content || !1),
          this.content &&
            ((this.containerRight = !!this.attributes.container_right),
            (this.buttonHide = !!this.attributes.button_hide),
            (this.buttonRight = !!this.attributes.button_right));
      }
      open() {
        if (!this.wrapper) {
          let e = `<div class="modal-wrapper">\n                         <div class="modal-mask modal-close"></div>\n                         <div class="modal-sidebar">\n                           ${
            this.buttonHide
              ? ""
              : '<button aria-label="close" class="modal-close modal-close-btn modal-sidebar__close-btn btn-reset"></button>'
          }\n                         </div>\n                       </div>`;
          (e = parseHTML(e)),
            (this.wrapper = e.querySelector(".modal-wrapper")),
            (this.wrapper.style.opacity = 0),
            (this.mask = e.querySelector(".modal-mask")),
            (this.contentWrapper = e.querySelector(".modal-sidebar")),
            (this.contentWrapper.style.opacity = 0),
            (this.closeButton = e.querySelector(".modal-close-btn")),
            this.containerRight &&
              ((this.contentWrapper.style.left = "auto"),
              (this.contentWrapper.style.right = "0px")),
            this.buttonRight &&
              ((this.closeButton.style.right = "0px"),
              (this.closeButton.style.left = "auto")),
            this.contentWrapper.appendChild(this.content),
            e.querySelectorAll(".modal-close").forEach((e) => {
              e.addEventListener("click", (e) => {
                e.preventDefault(), this.close();
              });
            }),
            this.appendChild(e),
            (this.TrapFocusLite = new TrapFocusLite(this)),
            this.TrapFocusLite.subscribe(({ key: e }) => {
              "Escape" == e && this.close();
            });
        }
        const e = window.innerWidth - document.body.clientWidth;
        document.body.classList.add("body-masked"),
          (document.body.style.paddingRight = `${e}px`),
          (this.wrapper.style.display = "block"),
          (this.wrapper.animate(
            [{ opacity: 0 }, { opacity: 1 }],
            300
          ).onfinish = (e) => {
            e.target.effect.target.style.opacity = 1;
          });
        const t = this.containerRight ? "150px" : "-150px";
        this.contentWrapper.animate(
          [
            { transform: `translateX(${t})`, opacity: 0 },
            { transform: "translateX(0px)", opacity: 1 },
          ],
          200
        ).onfinish = (e) => {
          (e.target.effect.target.style.transform = "translateX(0px)"),
            (e.target.effect.target.style.opacity = 1),
            this.TrapFocusLite.setFocus(),
            this.TrapFocusLite.setAttributes(this, {
              role: "dialog",
              "aria-modal": "true",
              "aria-live": "assertive",
            }),
            this.TrapFocusLite.removeAttributes(this, ["aria-hidden"]),
            this.next({ open: !0 });
        };
      }
      close() {
        (this.wrapper.animate([{ opacity: 1 }, { opacity: 0 }], 200).onfinish =
          (e) => {
            (e.target.effect.target.style.opacity = 0),
              (e.target.effect.target.style.display = "none"),
              document.body.classList.remove("body-masked"),
              (document.body.style.paddingRight = "0px"),
              this.TrapFocusLite.resetFocus(),
              this.TrapFocusLite.removeAttributes(this, [
                "role",
                "aria-modal",
                "aria-live",
              ]),
              this.TrapFocusLite.setAttributes(this, { "aria-hidden": "true" }),
              this.next({ open: !1 });
          }),
          (this.contentWrapper.animate(
            [
              { transform: "scale(1)", opacity: 1 },
              { transform: "scale(1.2)", opacity: 0 },
            ],
            200
          ).onfinish = (e) => {
            e.target.effect.target.style.opacity = 0;
          });
      }
    }
    customElements.define("global-sidebar", GlobalSidebar);
    class ShopifyUtils {
      constructor(e) {
        this.money_format = e.money_format || "£{{amount}}";
      }
      handleize(e) {
        return e
          .toLowerCase()
          .replace(/[^\w\u00C0-\u024f]+/g, "-")
          .replace(/^-+|-+$/g, "");
      }
      parseImgUrl(e, t) {
        const r = e.includes(".png") ? "png" : "jpg";
        return `${e.split("png" == r ? ".png" : ".jpg")[0]}_${t}x.${r}`;
      }
      formatMoney(e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        var r = "",
          a = /\{\{\s*(\w+)\s*\}\}/,
          s = t || this.money_format;
        function defaultOption(e, t) {
          return void 0 === e ? t : e;
        }
        function formatWithDelimiters(e, t, r, a) {
          if (
            ((t = defaultOption(t, 2)),
            (r = defaultOption(r, ",")),
            (a = defaultOption(a, ".")),
            isNaN(e) || null == e)
          )
            return 0;
          var s = (e = (e / 100).toFixed(t)).split(".");
          return (
            s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + r) +
            (s[1] ? a + s[1] : "")
          );
        }
        switch (s.match(a)[1]) {
          case "amount":
            r = formatWithDelimiters(e, 2);
            break;
          case "amount_no_decimals":
            r = formatWithDelimiters(e, 0);
            break;
          case "amount_with_comma_separator":
            r = formatWithDelimiters(e, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            r = formatWithDelimiters(e, 0, ".", ",");
        }
        return s.replace(a, r);
      }
    }
    class GlobalCart {
      constructor(e) {
        return (
          (window.GlobalCartObserver$ =
            window.GlobalCartObserver$ || new ObserverLite()),
          window.GlobalCartSingleton
            ? new Promise((e, t) => {
                window.GlobalCartObserver$.loaded
                  ? e(window.GlobalCartSingleton)
                  : window.GlobalCartObserver$.subscribe(() => {
                      e(window.GlobalCartSingleton);
                    });
              })
            : e
            ? ((window.GlobalCartSingleton = this),
              (this.ObserverLite = new ObserverLite()),
              (this.ShopifyUtils = new ShopifyUtils({
                money_format: e.money_format || !1,
              })),
              this.subscribe(() => {
                (window.GlobalCartObserver$.loaded = !0),
                  window.GlobalCartObserver$.next();
              }),
              void this.updateData())
            : new Promise((e, t) => {
                window.GlobalCartObserver$.subscribe(() => {
                  e(window.GlobalCartSingleton);
                });
              })
        );
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      serialize(e) {
        const t = {};
        function setValue(e, t, r) {
          const a = t.pop();
          let s = e;
          for (const e of t) s[e] || (s[e] = {}), (s = s[e]);
          s[a] = r;
        }
        const r = new FormData(e);
        for (let [e, a] of r.entries()) {
          setValue(
            t,
            e.split("[").map((e) => e.replace("]", "")),
            a
          );
        }
        return t;
      }
      addToCart(e) {
        return new Promise((t, r) => {
          e ||
            r({ description: "Sorry, there was a problem with that request" });
          e.items.filter(
            ({ id: e }) =>
              this.getLineItemsByVariantId(e)
                .map(({ quantity: e }) => e)
                .reduce((e, t) => e + t, 0) >= 6
          ).length && r({ type: "max_six" }),
            fetch("/cart/add.js", {
              method: "POST",
              body: JSON.stringify(e),
              headers: { "Content-Type": "application/json" },
            })
              .then((e) => e.json())
              .then((e) => {
                if (!e.items) throw e;
                this.updateData(), t();
              })
              .catch((e) => {
                console.log(e), r(e);
              });
        });
      }
      updateData() {
        return new Promise((e, t) => {
          this.getCartJSON().then((t) => {
            (this.cart = t), this.next({ eventType: "update" }), e();
          });
        });
      }
      updateQty(e, t, r) {
        (r = r || [{ key: e.key, qty: t }]),
          e?.properties?._bundle_id &&
            (r = r.concat(
              this.cart.items
                .filter(
                  ({ properties: t }) =>
                    t?._bundle_id == e.properties._bundle_id
                )
                .map(({ key: e }) => ({ key: e, qty: 0 }))
            )),
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              updates: r.reduce((e, t) => ({ ...e, [t.key]: t.qty }), {}),
            }),
          })
            .then((e) => e.json())
            .then((e) => {
              if (!e.token) throw e;
              (this.cart = e), this.next({ eventType: "update" });
            })
            .catch((e) => {
              console.log(e), this.next({ eventType: "error", error: e });
            });
      }
      removeItem(e) {
        fetch(e).then((e) => {
          this.next({ eventType: "update" });
        });
      }
      getCartJSON() {
        return new Promise((e, t) => {
          fetch("/cart.js")
            .then((e) => e.json())
            .then((t) => {
              e(t);
            });
        });
      }
      getLineItemsByVariantId(e) {
        return (
          (e = parseInt(e)),
          this.cart && this.cart.items
            ? this.cart.items.filter(({ variant_id: t }) => t == e)
            : []
        );
      }
      getLineItemsByProperty(e, t) {
        return this.cart && this.cart.items
          ? this.cart.items.filter((r) => {
              let a = r.properties?.[e];
              return (a = !!((null == t && a) || (a && a == t))), a;
            })
          : [];
      }
    }
    class GlobalLocaleLoader {
      constructor(e) {
        return (
          (window.GlobalLocaleLoaderObserver$ =
            window.GlobalLocaleLoaderObserver$ || new ObserverLite()),
          window.GlobalLocaleLoaderSingleton
            ? new Promise((e, t) => {
                window.GlobalLocaleLoaderObserver$.loaded
                  ? e(window.GlobalLocaleLoaderSingleton)
                  : window.GlobalLocaleLoaderObserver$.subscribe(() => {
                      e(window.GlobalLocaleLoaderSingleton);
                    });
              })
            : e
            ? ((window.GlobalLocaleLoaderSingleton = this),
              (this.settings = e),
              (this.ObserverLite = new ObserverLite()),
              this.subscribe(() => {
                (window.GlobalLocaleLoaderObserver$.loaded = !0),
                  window.GlobalLocaleLoaderObserver$.next();
              }),
              (this.translations = e.translations),
              void this.next())
            : new Promise((e, t) => {
                window.GlobalLocaleLoaderObserver$.subscribe(() => {
                  e(window.GlobalLocaleLoaderSingleton);
                });
              })
        );
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
    }
    class GlobalCartLineItem extends HTMLElement {
      constructor(e) {
        super(), (this.line_item = e?.line_item);
      }
      async connectedCallback() {
        (this.GlobalCart = await new GlobalCart()),
          (this.GlobalLocaleLoader = await new GlobalLocaleLoader()),
          this.render();
      }
      bind() {
        (this.qtyselector = this.querySelector(".js-sidebar-cart__update")),
          this.qtyselector?.addEventListener("change", (e) => {
            this.GlobalCart.updateQty(
              this.line_item,
              parseInt(this.qtyselector.value)
            );
          }),
          this.qtyselector?.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
          }),
          (this.removeButton = this.querySelector(".js-sidebar-cart__remove")),
          this.removeButton?.addEventListener("click", (e) => {
            e.preventDefault(),
              e.stopPropagation(),
              this.GlobalCart.updateQty(this.line_item, 0);
          });
      }
      render() {
        let {
          line: e,
          product_title: t,
          variant_title: r,
          image: a,
          url: s,
          discounts: i,
          key: n,
          quantity: o,
          final_line_price: c,
          original_line_price: l,
          properties: d,
          product_type: h,
          selling_plan_allocation: u,
        } = this.line_item;
        d = d || {};
        const m = d._gift || d._birthdayGift,
          p =
            d._RoswellSample ||
            h?.toLowerCase().includes("sample") ||
            t?.toLowerCase().includes("sample") ||
            r?.toLowerCase().includes("sample"),
          b = m || p || d._birthdayGift || d._bundle || d._csa_builder;
        let y = d._variantInventoryQty ? d._variantInventoryQty : 6;
        y = y > 6 ? 6 : y;
        const g = p || m,
          w = !(b || g || y <= 0);
        (!m && !p) || i.length || i.push({ title: "Ücretsiz" });
        const f = `\n      <div class="global-sidebar-cart-ui-item__image">\n      <img src="${a}?&width=128" \n           alt="${t}" \n           loading="lazy" \n           width="128" \n           height="128">\n           ${
          w ? "" : `<span class="counter global-cart-counter">${o}</span>`
        }\n      </div>\n      <div class="global-sidebar-cart-ui-item__details block flex row-wrap align-stretch justify-space">\n        <div class="global-sidebar-cart-ui-item__details-left flex column-wrap align-top justify-left">\n       \n          ${
          p
            ? `\n            <span class="global-sidebar-cart-ui-item__pre-title t-xs f-w600 t-ucase">${this.GlobalLocaleLoader.translations.cart.product.free_sample}</span>\n          `
            : ""
        }\n          ${
          m
            ? `\n            <span class="global-sidebar-cart-ui-item__pre-title t-xs f-w600 t-ucase">${this.GlobalLocaleLoader.translations.cart.product.free_gift}</span>\n          `
            : ""
        }\n          ${
          d._birthdayGift
            ? `\n            <span class="global-sidebar-cart-ui-item__pre-title t-xs f-w600 t-ucase">${this.GlobalLocaleLoader.translations.cart.product.birthday_gift}</span>\n          `
            : ""
        }  \n          ${
          d._bundle
            ? `\n          <span class="global-sidebar-cart-ui-item__pre-title t-xs f-w600 t-ucase">${this.GlobalLocaleLoader.translations.cart.product.bundle}</span>\n          `
            : ""
        }\n\n          ${
          u
            ? `\n          <span class="global-sidebar-cart-ui-item__pre-title t-xs f-w600 t-ucase">${this.GlobalLocaleLoader.translations.cart.product.subscription}</span>\n          `
            : ""
        }\n\n          <span class="global-sidebar-cart-ui-item__title d-block f-w600">${t}</span>\n\n          ${
          r
            ? ` \n            <span class="global-sidebar-cart-ui-item__meta d-block">${r}</span>\n          `
            : ""
        }\n\n          ${
          u?.selling_plan?.name
            ? ` \n          <span class="global-sidebar-cart-ui-item__meta d-block">${u.selling_plan.name}</span>\n          `
            : ""
        }\n\n          ${
          d.shipping_interval_frequency
            ? `\n            <span class="global-sidebar-cart-ui-item__sub-title"><i class="wayfx-icon wayfx-icon-rotate"></i> Delivers every ${d.shipping_interval_frequency} days</span>\n          `
            : ""
        }\n          ${
          d._csa_builder
            ? `\n          <span class="global-sidebar-cart-ui-item__sub-title">CSA Kit Builder: ${d._csa_builder}</span>\n          `
            : ""
        }\n          ${
          w
            ? `\n       <div class="qty-remove">     <select class="js-sidebar-cart__update global-sidebar-cart-ui-item__qty styled-selector" \n                    name="qty" data-id="${n}" data-line="${e}" aria-label="quantity" >\n              ${new Array(
                y + 1
              )
                .fill(!1)
                .map(
                  (e, t) =>
                    `<option value="${t}" ${
                      t == o ? "selected" : ""
                    }>${t}</option>`
                )
                .join()}\n            </select>\n         <button type="button" class="js-sidebar-cart__remove global-sidebar-cart-ui-item__remove" data-id="${n}" data-qty="0" data-line="${e}">\n              <span>Kaldır</span>\n            </button>\n   </div>\n        `
            : ""
        }\n        </div>\n        <div class="global-sidebar-cart-ui-item__details-right">\n          ${
          m
            ? ""
            : `\n            <button style="display: none;" type="button" class="js-sidebar-cart__remove global-sidebar-cart-ui-item__remove" data-id="${n}" data-qty="0" data-line="${e}">\n              <span>Kaldır</span>\n            </button>\n          `
        }\n          <span class="global-sidebar-cart-ui-item__price">\n            ${
          l != c
            ? `\n              <small class="global-sidebar-cart-ui-item__price-lined"><s>${this.GlobalCart.ShopifyUtils.formatMoney(
                l
              )}</s></small>\n            `
            : ""
        }\n            ${this.GlobalCart.ShopifyUtils.formatMoney(
          c
        )}\n          </span>\n          ${
          b && i && i.length
            ? `\n            ${i
                .map(
                  ({ title: e }) =>
                    `<span class="global-sidebar-cart-ui-item__discount d-block tar"><i class="wayfx-icon wayfx-icon-tag"></i>${e}</span>`
                )
                .join("")}\n          `
            : ""
        }\n        </div>\n      </div>\n    `;
        (this.innerHTML = `\n      ${
          g
            ? `<div class="global-sidebar-cart-ui-item block flex row-wrap align-space justify-left">${f}</div>`
            : `<a aria-label="View ${t}" href="${s}" class="global-sidebar-cart-ui-item block flex row-wrap align-space justify-left">${f}</a>`
        }\n    `),
          this.bind();
      }
    }
    customElements.define(
      "global-sidebar-cart-ui-line-item",
      GlobalCartLineItem
    );
    class GlobalSidebarCartUI extends HTMLElement {
      constructor() {
        super(), (this.extensions = []);
      }
      init() {
        return (
          (this.connected = !0),
          new Promise(async (e, t) => {
            (this.ObserverLite = new ObserverLite()),
              (this.GlobalCart = await new GlobalCart());
            const { translations: r } = await new GlobalLocaleLoader();
            (this.translations = r || !1),
              this.GlobalCart.subscribe((e) => {
                this.render(e);
              }),
              e();
          })
        );
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      async connectedCallback() {
        this.connected ||
          "TEMPLATE" == this.parentElement.nodeName ||
          ((this.connected = !0),
          (this.sidebarElement = document.querySelector(".js-sidebar-cart")),
          await this.init(),
          this.GlobalCart && this.GlobalCart.cart
            ? this.render()
            : this.GlobalCart.updateData());
      }
      render(e) {
        if (
          ((this.extensions = this.extensions.map(
            (e) => (
              (e.id = e.id || Math.floor(999999999999 * Math.random())), e
            )
          )),
          this.header ||
            ((this.header = document.createElement("div")),
            this.header.classList.add(
              "global-sidebar-cart-ui-header",
              "block-rel"
            ),
            (this.header.innerHTML = `\n        <div class="global-sidebar-cart-ui-header__nav">\n          <button aria-label="close" type="button" class="js-sidebar-cart__close-sidebar global-sidebar-cart-ui-header__close">\n            <i class="wayfx-icon wayfx-icon-close" aria-hidden="true"></i>\n          </button>\n          <span class="global-sidebar-cart-ui-header__title flex justify-center row-wrap block-rel align-center">${this.translations.cart.general.title}</span>\n        </div>\n      `),
            this.appendChild(this.header),
            this.querySelector(
              ".js-sidebar-cart__close-sidebar"
            ).addEventListener("click", (e) => {
              e.preventDefault(), this.sidebarElement.close();
            })),
          e?.error?.message)
        ) {
          let t = parseHTML(
            `<p style="text-align:center;" class="js-cart-errors errors qty-error">${e.error.message}</p>`
          );
          this.header.appendChild(t),
            (t = this.querySelector(".js-cart-errors")),
            setTimeout(() => {
              t.remove();
            }, 2e3);
        }
        this.postHeaderExtensionPoint ||
          ((this.postHeaderExtensionPoint = document.createElement("div")),
          this.postHeaderExtensionPoint.classList.add(
            "global-sidebar-cart-ui-post-header"
          ),
          this.appendChild(this.postHeaderExtensionPoint)),
          this.main ||
            ((this.main = document.createElement("div")),
            this.main.classList.add("global-sidebar-cart-ui-item-list"),
            this.appendChild(this.main)),
          this.preFooterExtensionPoint ||
            ((this.preFooterExtensionPoint = document.createElement("div")),
            this.preFooterExtensionPoint.classList.add(
              "global-sidebar-cart-ui-pre-footer"
            ),
            this.appendChild(this.preFooterExtensionPoint)),
          this.footer ||
            ((this.footer = document.createElement("div")),
            this.footer.classList.add("global-sidebar-cart-ui-footer"),
            this.appendChild(this.footer)),
          (this.main.innerHTML = "");
        const {
          items: t,
          original_total_price: r,
          total_price: a,
          total_discount: s,
        } = this.GlobalCart.cart;
        this.main.classList.toggle("flex", !t.length),
          t.length
            ? t.forEach((e, t) => {
                e &&
                  ((e.line = t + 1),
                  this.main.appendChild(
                    new GlobalCartLineItem({ line_item: e })
                  ));
              })
            : (this.main.innerHTML = `\n      <div class="global-sidebar-cart__empty">\n        <h4 class="h4--primary">Sepetiniz Boş</h4>\n        <p>${this.translations.cart.general.empty_message}</p>\n        <a href="/collections/all" class="btn btn--full btn--large btn--primary">Şimdi Alışveriş Yap</a>\n      </div>\n    `),
         (this.footer.innerHTML = t.length
          ? `
            <form action="/cart" method="post" class="global-sidebar-cart-ui-footer__form flex row-wrap align-center">
              <div class="global-sidebar-cart-ui-footer__totals">
                <span class="global-sidebar-cart-ui-footer__subtotal d-block">
                  ${this.translations.cart.general.subtotal}
                </span>
                <span class="global-sidebar-cart-ui-footer__price d-block">
                  ${this.GlobalCart.ShopifyUtils.formatMoney(a)}
                </span>
              </div>

              <div class="cart-drawer-terms">
                <input type="checkbox" id="CartDrawerTerms" required>
                <label for="CartDrawerTerms">
                  <a href="/policies/terms-of-service" target="_blank">
                    Mesafeli Satış Sözleşmesi şartlarını
                  </a>'nı okudum ve kabul ediyorum.
                </label>
              </div>

              <button
                aria-label="Go to checkout"
                name="checkout"
                class="js-sidebar-cart__checkout global-sidebar-cart-ui-footer__btn btn--secondary btn--full">
                <i class="wayfx-icon wayfx-icon-lock"></i>
                ${this.translations.cart.general.checkout}
              </button>
            </form>
          `
          : ""),
          (this.rendered = !0),
          this.bind(),
          this.extensions.map(async (e) => {
            const { rendered: r, hideOnEmptyCart: a, extensionPoint: s } = e,
              i =
                "header:bottom" == s
                  ? this.postHeaderExtensionPoint
                  : this.preFooterExtensionPoint;
            if (
              ((e.render = !(!t.length || r)),
              (e.remove = !(t.length || !a || !r)),
              e.render)
            ) {
              if (e.loader) {
                if ((await e.loader.load()).error) return (e.render = !1), e;
              }
              i.prepend(
                parseHTML(
                  `<div data-cart-extension="${e.id}">${e.content}</div>`
                )
              ),
                (e.element = i.querySelector(
                  `[data-cart-extension="${e.id}"]`
                )),
                (e.rendered = !0);
            }
            return (
              e.remove &&
                (e.element.remove(), delete e.rendered, delete e.element),
              e
            );
          });
      }
      bind() {
        this.querySelector(".js-sidebar-cart__checkout")?.addEventListener(
          "click",
          (e) => {
            const termsCheckbox = document.querySelector('#CartDrawerTerms');
            if(termsCheckbox.checked == false) {
              termsCheckbox.setCustomValidity("Ödeme işlemi için satış şartları ve koşullarını kabul etmelisiniz.");
              return;
            }
            e.currentTarget.classList.add("btn--loading");
          }
        );
      }
    }
    function DomReadyPromise() {
      return new Promise(function (e, t) {
        "loading" !== document.readyState
          ? e()
          : addEventListener("DOMContentLoaded", () => {
              e();
            });
      });
    }
    customElements.define("global-sidebar-cart-ui", GlobalSidebarCartUI);
    class GlobalQtySelector extends HTMLElement {
      constructor() {
        super(), (this.ObserverLite = new ObserverLite());
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      connectedCallback() {
        DomReadyPromise()
          .then(() => {
            this.mounted || this.mount();
          })
          .catch((e) => {
            console.log(e);
          });
      }
      update(e) {
        const { input: t } = this,
          r = parseInt(t.value),
          a = r + 1,
          s = r - 1,
          i = t.min || 0,
          n = t.max || 1 / 0;
        "add" == e && a <= n && (t.value = a),
          "remove" == e && s >= i && (t.value = s),
          clearTimeout(this.timeoutId),
          (this.timeoutId = setTimeout(() => {
            this.next(), t.dispatchEvent(new Event("change"));
          }, 500));
      }
      mount() {
        if (((this.mounted = !0), !window.GlobalQtySelectorStylesInjected)) {
          const e =
            "\n        <style type=\"text/css\">\n          global-qty-selector{\n            --elementSize:40px;\n            display:flex;\n          }\n\n          .qty-selector-disabled{\n            opacity:0.2;\n            pointer-events:none;\n          }\n\n          .qty-selector__btn{\n            width:var(--elementSize);\n            height:var(--elementSize);\n            border:1px solid #666;\n            color:#000;\n            outline:none;\n            border-radius:5px;\n            transition: all .1s ease-in;\n            position:relative;\n          }\n\n          .qty-selector__btn:hover{\n            background:#000;\n            border-color:#000;\n            color:#fff;\n          }\n\n          .qty-selector__btn:after{\n            content:'+';\n            position:absolute;\n            top:50%;\n            left:50%;\n            transform:translate(-50%,-50%);\n            font-size:20px;\n          }\n          \n          .qty-selector__btn--dec:after{\n            content:'-';\n          }\n\n          input.qty-selector__input{\n            width:var(--elementSize);\n            height:var(--elementSize);\n            border:0px;\n            outline:0px;\n            pointer-events:none;\n            padding:2px;\n            margin:0;\n            text-align:center;\n          }\n        </style>\n      ";
          (window.GlobalQtySelectorStylesInjected = !0),
            document.body.append(parseHTML(e));
        }
        const e = parseHTML(
            '<button class="js-qty-selector__btn--inc btn-reset qty-selector__btn qty-selector__btn--inc" aria-label="Add Item" type="button"></button>'
          ),
          t = parseHTML(
            '<button class="js-qty-selector__btn--dec btn-reset qty-selector__btn qty-selector__btn--dec" aria-label="Remove Item" type="button"></button>'
          );
        this.prepend(t),
          this.append(e),
          (this.increase = this.querySelector(".js-qty-selector__btn--inc")),
          (this.decrease = this.querySelector(".js-qty-selector__btn--dec")),
          (this.input = this.querySelector("input")),
          this.input.classList.add("qty-selector__input", "reset-input"),
          this.input.setAttribute("readonly", !0),
          this.input.setAttribute("type", "text"),
          this.increase.addEventListener("click", () => {
            this.update("add");
          }),
          this.decrease.addEventListener("click", () => {
            this.update("remove");
          });
      }
    }
    customElements.define("global-qty-selector", GlobalQtySelector);
    class GlobalVariantQtyHelper {
      constructor(e) {
        (this.ObserverLite = new ObserverLite()), this.init(e);
      }
      async init(e) {
        (this.cart = await new GlobalCart()),
          this.updateSettings(e),
          this.cart.subscribe(() => {
            this.next();
          });
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      updateSettings(e) {
        (this.settings = e), this.next();
      }
      getVariantData() {
        return new Promise(async (e, t) => {
          this.cart = this.cart || (await new GlobalCart());
          const r = this.cart
            .getLineItemsByVariantId(this.settings.variantId)
            .map(({ quantity: e }) => e)
            .reduce((e, t) => e + t, 0);
          e({
            stock: this.settings.variantInventoryQty,
            cart: r,
            remaining: this.settings.variantInventoryQty - r,
            managed: this.settings.variantInventoryManagement,
            data: this.settings.data,
          });
        });
      }
    }
    class NiceScrollSlider {
      constructor({ slides: e, nicescroller: t }) {
        (this.nicescroller = t),
          (this.slides = e),
          (this.slides[0].dataset.nicescrollActive = !0),
          (this.activeIndex = 0);
      }
      goToNextSlide() {
        let e = this.activeIndex + 1;
        (e = e > this.slides.length - 2 ? 0 : e),
          (this.activeIndex = e),
          this.animate();
      }
      goToPrevSlide() {
        let e = this.activeIndex - 1;
        (e = e >= 0 ? e : this.slides.length - 1),
          (this.activeIndex = e),
          this.animate();
      }
      animate() {
        let e = !1;
        this.slides.forEach((t, r) => {
          (t.dataset.nicescrollActive = r == this.activeIndex),
            this.activeIndex == r && (e = t);
        });
        const t =
          this.nicescroller.getBoundingClientRect().x -
          e.getBoundingClientRect().x;
        this.nicescroller.scrollBy({ left: 0 - t, top: 0, behavior: "smooth" });
      }
    }
    class NiceScroll extends HTMLElement {
      constructor() {
        super(), (this.moving = !1);
      }
      connectedCallback() {
        DomReadyPromise().then(() => {
          if (!this.mounted) {
            this.id = Math.floor(999999999999999 * Math.random());
            const {
              slideTarget: e,
              showControls: t,
              hideScrollBar: r,
            } = this.attributes;
            (this.slideTarget = e?.value || !1),
              (this.showControls = !!t),
              (this.hideScrollBar = !!r),
              (this.mounted = !0),
              (this.style.userSelect = "none"),
              (this.resizeTimeout = `resizeTimeout_${this.id}`),
              this.mount(),
              this.build(),
              this.bind();
          }
        });
      }
      mount() {
        if (!window.NiceScrollMounted) {
          const e =
            '\n        <style type="text/css">\n\n          nice-scroll{\n            display:block;\n          }\n\n          .nice-scroll--has-controls{\n            position:relative;\n          }\n\n          .nice-scroll--scrollbar-active{\n            padding-bottom: var(--gutter-unit);\n          }\n\n          .nice-scroll__content{\n            overflow-x: auto;\n            overflow-y:hidden;\n            display:block;\n            width:100%;\n            padding-bottom:16px;\n          }\n\n          .nice-scroll__content .arrow{\n            display:none;\n            top:calc(50% - 8px);\n            transform:translate(80%,-50%);\n          }\n\n          .nice-scroll__content .arrow--left{\n            transform:translate(-80%,-50%);\n          }\n\n          .nice-scroll__content label{\n            position: relative;\n          }\n\n          .nice-scroll__content label input{\n            width:100%;\n            height:100%;\n            top:0;\n            left:0;\n            margin:0;\n          }\n\n          .nice-scroll__content::-webkit-scrollbar {\n            width: 50%;\n            height:5px;\n          }\n\n          .nice-scroll__content::-webkit-scrollbar-track {\n            background: #eee;\n          }\n\n          .nice-scroll__content::-webkit-scrollbar-thumb {\n            background: #000;\n          }\n  \n          .nice-scroll__content::-webkit-scrollbar-thumb:hover {\n            background: #000;\n          }\n\n          .nice-scroll__content--no-scrollbar{\n            padding-bottom:0;\n          }\n\n          .nice-scroll__content--no-scrollbar::-webkit-scrollbar {\n            display:none;\n          }\n\n          .nice-scroll__content--no-scrollbar .arrow{\n            top:50%;\n          }\n\n        </style>\n      ';
          (window.NiceScrollMounted = !0), document.body.append(parseHTML(e));
        }
      }
      build() {
        (this.innerHTML = `\n      <div class="nice-scroll__content" data-nicescroll-content>\n        ${this.innerHTML}\n      </div>\n    `),
          (this.content = this.querySelector("[data-nicescroll-content]")),
          this.hideScrollBar &&
            this.content.classList.add("nice-scroll__content--no-scrollbar");
        const e = (this.slideTarget =
          this.querySelectorAll(this.slideTarget) ||
          this.querySelectorAll("[data-nicescroll-slide]"));
        e?.length &&
          this.showControls &&
          (this.classList.add("nice-scroll--has-controls"),
          this.content.append(
            parseHTML(
              '\n      <button class="arrow arrow--left"  data-nicescroll-slide-prev aria-label="Previous item"></button>\n      <button class="arrow arrow--right" data-nicescroll-slide-next aria-label="Next item"></button>\n      '
            )
          ),
          (this.controls = {
            prev: this.querySelector("[data-nicescroll-slide-prev]"),
            next: this.querySelector("[data-nicescroll-slide-next]"),
          }),
          (this.slider = new NiceScrollSlider({
            slides: e,
            nicescroller: this.content,
          })));
      }
      toggleControls() {
        clearTimeout(this.resizeTimeout),
          (this.resizeTimeout = setTimeout(() => {
            const { width: e } = this.content.getBoundingClientRect(),
              t = Math.floor(e) < this.content.scrollWidth;
            (this.controls.prev.style.display = t ? "block" : "none"),
              (this.controls.next.style.display = t ? "block" : "none"),
              this.hideScrollBar ||
                this.classList.toggle("nice-scroll--scrollbar-active", t);
          }, 500));
      }
      bind() {
        this.slider &&
          (this.controls.prev.addEventListener("click", (e) => {
            e.preventDefault(this.slider.goToPrevSlide());
          }),
          this.controls.next.addEventListener("click", (e) => {
            e.preventDefault(this.slider.goToNextSlide());
          }),
          new ResizeObserver((e) => {
            for (const t of e) t.contentBoxSize && this.toggleControls();
          }).observe(this.content));
        let e,
          t,
          r = !1;
        const resetCursorAndMouseDownState = () => {
          (r = !1), (this.content.style.cursor = "grab");
        };
        this.content.addEventListener("mousedown", (a) => {
          (r = !0),
            (this.content.style.cursor = "grabbing"),
            (e = a.pageX - this.content.offsetLeft),
            (t = this.content.scrollLeft);
        }),
          this.content.addEventListener(
            "mouseleave",
            resetCursorAndMouseDownState
          ),
          this.content.addEventListener(
            "mouseup",
            resetCursorAndMouseDownState
          ),
          this.addEventListener("mousemove", (a) => {
            if (!r) return;
            a.preventDefault();
            const s = 1 * (a.pageX - this.content.offsetLeft - e);
            this.content.scrollLeft = t - s;
          });
      }
    }
    customElements.define("nice-scroll", NiceScroll);
    class ModalBox {
      constructor({ content: e, settings: t }) {
        window.ModalBoxInstance && window.ModalBoxInstance.close(),
          (window.ModalBoxInstance = this),
          (this.content = e),
          (this.settings = t || { containerCloseButton: !0 }),
          (this.ObserverLite = new ObserverLite());
      }
      subscribe(e) {
        return this.ObserverLite.subscribe(e);
      }
      next(e) {
        this.ObserverLite.next(e);
      }
      toggle() {
        this.active ? this.close() : this.open();
      }
      open() {
        return (
          (this.active = !0),
          this.next({ type: "open" }),
          new Promise((e, t) => {
            if (!this.wrapper) {
              let e = `<div class="modal-wrapper ${
                this.settings.wrapperClass ? this.settings.wrapperClass : ""
              }"\n                            style="${
                this.settings.wrapperStyles ? this.settings.wrapperStyles : ""
              }">\n                         <div class="modal-mask modal-close"></div>\n                         <div class="modal-flex">\n                           <div class="modal-content  \n                                       ${
                this.settings.contentClass
                  ? `${this.settings.contentClass}`
                  : ""
              }\n                                       ${
                this.settings.overlayClose ? "modal-close" : ""
              }">\n                              ${
                this.settings.containerCloseButton
                  ? '<button aria-label="close" class="modal-close modal-close-btn btn-reset"></button>'
                  : ""
              }\n                           </div>\n                         </div>\n                       </div>`;
              (e = parseHTML(e)),
                (this.wrapper = e.querySelector(".modal-wrapper")),
                (this.wrapper.style.opacity = 0),
                (this.mask = e.querySelector(".modal-mask")),
                (this.content = parseHTML(this.content)),
                (this.contentWrapper = e.querySelector(".modal-content")),
                (this.contentWrapper.style.opacity = 0),
                this.contentWrapper.appendChild(this.content),
                e.querySelectorAll(".modal-close").forEach((e) => {
                  e.addEventListener("click", (e) => {
                    e.preventDefault(), this.close();
                  });
                }),
                document.body.appendChild(e),
                (this.TrapFocusLite = new TrapFocusLite(this.wrapper)),
                this.TrapFocusLite.subscribe(({ key: e }) => {
                  "Escape" == e && this.close();
                });
            }
            window.innerWidth, document.body.clientWidth;
            document.body.classList.add("body-masked"),
              (this.wrapper.style.display = "block"),
              (this.wrapper.animate(
                [{ opacity: 0 }, { opacity: 1 }],
                300
              ).onfinish = (e) => {
                e.target.effect.target.style.opacity = 1;
              }),
              (this.contentWrapper.animate(
                [
                  { transform: "translateY(100px)", opacity: 0 },
                  { transform: "translateY(0px)", opacity: 1 },
                ],
                300
              ).onfinish = (t) => {
                (t.target.effect.target.style.transform = "translateY(0px)"),
                  (t.target.effect.target.style.opacity = 1),
                  this.TrapFocusLite.setFocus(),
                  this.TrapFocusLite.setAttributes(this.wrapper, {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-live": "assertive",
                  }),
                  this.TrapFocusLite.removeAttributes(this.wrapper, [
                    "aria-hidden",
                  ]),
                  this.next({ type: "open:rendered" }),
                  e();
              });
          })
        );
      }
      close() {
        (this.active = !1),
          this.next({ type: "close" }),
          (this.wrapper.animate(
            [{ opacity: 1 }, { opacity: 0 }],
            200
          ).onfinish = (e) => {
            (e.target.effect.target.style.opacity = 0),
              document.body.classList.remove("body-masked"),
              (document.body.style.paddingRight = "0px"),
              (this.wrapper.style.display = "none");
          }),
          (this.contentWrapper.animate(
            [
              { transform: "scale(1)", opacity: 1 },
              { transform: "scale(1.2)", opacity: 0 },
            ],
            200
          ).onfinish = (e) => {
            (e.target.effect.target.style.opacity = 0),
              this.TrapFocusLite.resetFocus(),
              this.TrapFocusLite.removeAttributes(this.wrapper, [
                "role",
                "aria-modal",
                "aria-live",
              ]),
              this.TrapFocusLite.setAttributes(this.wrapper, {
                "aria-hidden": "true",
              }),
              this.next({ type: "close:finish" });
          });
      }
      destroy() {
        this.wrapper.remove();
      }
    }
    class DynamicImporter {
      constructor(e) {
        if (window.DynamicImporterSingleton)
          return (
            (window.DynamicImporterSingleton.items =
              window.DynamicImporterSingleton.items.concat(
                e.filter((e) => !this.items?.find(({ url: t }) => e.url !== t))
              )),
            window.DynamicImporterSingleton
          );
        (this.observer = new ObserverLite()),
          (this.items = e),
          (window.DynamicImporterSingleton = this);
      }
      async loadScript(e) {
        return (
          "js" === e.type
            ? (e.loading =
                e.loading ||
                new Promise((t, r) => {
                  import(`${e.url}`)
                    .then((r) => {
                      (e.loaded = !0), t(r);
                    })
                    .catch((e) => {
                      console.log(e), r({ error: !0 });
                    });
                }))
            : (e.loading =
                e.loading ||
                new Promise((t) => {
                  try {
                    const r = document.createElement("link");
                    (r.rel = "stylesheet"),
                      (r.href = e.url),
                      document.head.appendChild(r),
                      (r.onload = () => {
                        (e.loaded = !0), t(r);
                      });
                  } catch (e) {
                    console.log(e), reject({ error: !0 });
                  }
                })),
          e.loading
        );
      }
      load() {
        return new Promise((e, t) => {
          const r = this.items
            .filter(({ loaded: e }) => !e)
            .map((e) => this.loadScript(e));
          Promise.all(r)
            .then((t) => {
              this.observer.next(), e({ results: t });
            })
            .catch((t) => {
              e({ error: !0 });
            });
        });
      }
    }
    function customerPrivacyApi() {
      function initClarity() {
        "function" == typeof window.clarity && window.clarity("consent");
      }
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        (e) => {
          e
            ? console.error(e)
            : (document.addEventListener("visitorConsentCollected", (e) => {
                e.detail.analyticsAllowed && initClarity();
              }),
              window.Shopify.customerPrivacy.analyticsProcessingAllowed() &&
                initClarity());
        }
      );
    }
    async function klaviyoSubscribe(e) {
      const t = new FormData(e),
        r = Object.fromEntries(t.entries());
      if (!r.email || !r.key || !r.list_id || r.hpf) return !1;
      try {
        return (
          202 ===
          (
            await fetch(
              `https://a.klaviyo.com/client/subscriptions/?company_id=${r.key}`,
              options(r)
            )
          ).status
        );
      } catch (e) {
        return !1;
      }
    }
    const options = (e) => ({
      method: "POST",
      headers: { revision: "2024-02-15", "content-type": "application/json" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: `${e.source ?? "No source specified"}`,
            profile: {
              data: { type: "profile", attributes: { email: e.email } },
            },
          },
          relationships: { list: { data: { type: "list", id: e.list_id } } },
        },
      }),
    });
    var e = __webpack_require__(195);
    function KSnavigation(e) {
      let t, r, a, s;
      function markup(i) {
        !(function wrapperMarkup(r) {
          if (r) {
            for (var a = t.parentNode; t.firstChild; )
              a.insertBefore(t.firstChild, t);
            return void removeElement(t);
          }
          (t = createDiv("navigation-wrapper")),
            e.container.parentNode.appendChild(t),
            t.appendChild(e.container);
        })(i),
          (function dotMarkup(a) {
            if (a) return void removeElement(r);
            if (e.track.details && isFinite(e.track.details.maxIdx)) {
              r = createDiv("dots");
              [...Array(e.track.details.maxIdx + 1).keys()].forEach((t, a) => {
                var s = createDiv("dot");
                s.addEventListener("click", () => e.moveToIdx(a)),
                  r.appendChild(s);
              }),
                t.appendChild(r);
            }
          })(i),
          e.options.hideArrows ||
            (function arrowMarkup(r) {
              if (r) return removeElement(a), void removeElement(s);
              (a = createDiv("arrow arrow--left")),
                a.addEventListener("click", () => e.prev()),
                (s = createDiv("arrow arrow--right")),
                s.addEventListener("click", () => e.next()),
                t.appendChild(a),
                t.appendChild(s);
            })(i);
      }
      function removeElement(e) {
        e && e.parentNode?.removeChild(e);
      }
      function createDiv(e) {
        var t = document.createElement("div");
        return e.split(" ").forEach((e) => t.classList.add(e)), t;
      }
      function updateClasses() {
        if (!e || !e.track.details) return;
        const t =
          !!e.container.parentNode.classList.contains("navigation-wrapper") &&
          e.container.parentNode;
        if (t) {
          const r =
            !e.options.slides || e.slides.length <= e.options.slides.perView;
          t.classList.toggle("navigation-wrapper--no-padding", r);
        }
        var i = e.track.details.rel;
        r &&
          r.children.length &&
          (Array.from(r.children).forEach(function (e, t) {
            t === i
              ? e.classList.add("dot--active")
              : e.classList.remove("dot--active");
          }),
          (r.style.display =
            e.slides.length <= e.options.slides.perView ? "none" : "flex")),
          a &&
            s &&
            ((a.style.display =
              !e.options.slides || e.slides.length <= e.options.slides.perView
                ? "none"
                : "block"),
            (s.style.display =
              !e.options.slides || e.slides.length <= e.options.slides.perView
                ? "none"
                : "block"),
            0 === i
              ? a.classList.add("arrow--disabled")
              : a.classList.remove("arrow--disabled"),
            i === e.track.details.slides.length - 1
              ? s.classList.add("arrow--disabled")
              : s.classList.remove("arrow--disabled"));
      }
      e.on("created", () => {
        markup(), updateClasses(), e.update();
      }),
        e.on("update", () => {
          updateClasses();
        }),
        e.on("optionsChanged", () => {
          markup(!0), markup(), updateClasses();
        }),
        e.on("slideChanged", () => {
          updateClasses();
        }),
        e.on("destroyed", () => {
          markup(!0);
        });
    }
    class AlgoliaSearchHeader extends HTMLElement {
      constructor() {
        super(),
          (this.query = ""),
          (this.hasBeenOpened = !1),
          (this.maxProductsDisplay = 4),
          this.previousProductResults,
          (this._searchData = null),
          (this._linksData = null),
          (this._productData = null),
          (this.LinksMax = 20);
      }
      async connectedCallback() {
        await DomReadyPromise(),
          (this.agForm = this.querySelector("form")),
          (this.agFormInput = this.querySelector("form input")),
          (this.agProducts = this.querySelector(".ag-products")),
          (this.agLinks = this.querySelector(".ag-links")),
          (this.mask = document.querySelector(
            ".shopify-section.algolia .algolia-mask"
          ));
        const t = this.querySelector("template");
        t && ((this.config = JSON.parse(t.innerHTML)), t.remove()),
          this.initHeaderSearchIcon(),
          this.initCloseButton(),
          this.initMaskClose(),
          this.initForm(),
          (this.agSearch = await new e.AgSearchUtil({
            app_id: this.config.agConfig.appId,
            search_api_key: this.config.agConfig.publicApi,
          })),
          this.setAttribute("query", this.query);
      }
      attributeChangedCallback(e, t, r) {
        "query" === e && r !== t && ((this.query = r), this.performSearch(r));
      }
      static get observedAttributes() {
        return ["query"];
      }
      get searchData() {
        return this._searchData;
      }
      set searchData(e) {
        (this._searchData = e),
          this.buildLinksData(),
          this.arrayCompare(
            this.previousProductResults.map((e) => e.sku),
            this.searchData.products.hits.map((e) => e.sku)
          ) || this.buildProductData();
      }
      get linksData() {
        return this._linksData;
      }
      set linksData(e) {
        (this._linksData = e), this.renderLinks();
      }
      get productData() {
        return this._productData;
      }
      set productData(e) {
        (this._productData = e), this.renderProducts();
      }
      initForm() {
        this.agFormInput.addEventListener(
          "keyup",
          (function debounce(e, t) {
            let r;
            return function (...a) {
              clearTimeout(r),
                (r = setTimeout(() => {
                  e(...a);
                }, t));
            };
          })((e) => {
            this.setAttribute("query", e.target.value);
          }, this.config.agConfig.debounce)
        );
      }
      initHeaderSearchIcon() {
        document
          .getElementById("header-search-icon")
          .addEventListener("click", () => {
            this.classList.contains("hide")
              ? this.openSearch()
              : this.closeSearch();
          });
      }
      initCloseButton() {
        document
          .getElementById("algoliaSearchClose")
          .addEventListener("click", () => this.closeSearch());
      }
      initMaskClose() {
        this.mask.addEventListener("click", () => this.closeSearch());
      }
      buildLinksData() {
        this.agLinks.innerHTML = "";
        const e = [];
        (this.linksCount = 0),
          Object.keys(this.config.agConfig.indices).forEach((t) => {
            if ("products" == t) return;
            let r = {};
            this.searchData[t]?.hits.forEach((e) => {
              this.linksCount += 1;
              let a = "articles" == t ? `${e.blog.handle}/` : "";
              const s = "articles" === t ? "blogs" : t;
              r[e.title] = `/${s}/${a}${e.handle}`;
            }),
              e.push({ [t]: r });
          });
        const t = this.mergeResults(e, ["pages", "articles"], "content");
        this.updateTitles(t),
          (this.linksData = this.linksCount ? t : this.config.defaultLinks);
      }
      buildProductData() {
        this.productData = this.searchData.products.hits;
      }
      renderLinks() {
        const e = this.query && this.linksCount ? this.LinksMax : 10,
          t = this.linksData
            .map((t) => {
              const [r, a] = Object.entries(t)[0],
                s = Object.entries(a)
                  .slice(0, e)
                  .map(
                    ([e, t]) =>
                      `<li class="t-xs lh-rm ticklist"><a href="${t}">${e}</a></li>`
                  )
                  .join("");
              return s
                ? `<div class="ag-links__wrapper"><h2 class="t-s f-w600 lh-r t-ucase">${r}</h2><ul>${s}</ul></div>`
                : null;
            })
            .join("");
        this.agLinks.innerHTML = t;
      }
      renderProducts() {
        this.renderResultsTitle();
        const e = parseHTML(
          `<ul class="ag-products-slider flex ticklist">${(this.productData
            .length
            ? this.productData.slice(0, this.maxProductsDisplay)
            : this.defaultProducts
          )
            .map((e) => {
              const t = e.image,
                r =
                  e.variant_title &&
                  "Default Title" !== e.variant_title &&
                  !e.option_names.includes("size")
                    ? e.variant_title
                    : e.title,
                a = e.meta?.sf_product_hero?.sub_heading || "",
                s = (e.price, e.objectID ? `?variant=${e.objectID}` : ""),
                i = `/products/${e.handle}${s}`;
              return `<li class="product-card keen-slider__slide">\n          <div>\n          <a href="${i}" class="">\n            <img src="${t}"\n              alt="${r}"\n              width="400"\n              height="400"\n              class="product-card__image d-block row--d2">\n          </a>\n          <a href="${i}" class="product-card__title d-block row--d2 t-xs lh-m f-w600 t-ucase tac">${r}</a>\n          <div class="product-card__description d-block row--d2 t-xxxs f-w400 lh-r tac">${a}</div>\n          </div>\n        </li>`;
            })
            .join("")}</ul>`
        );
        this.agProducts.querySelector(".ag-products-slider")?.remove(),
          this.agProducts.appendChild(e),
          this.buildKeenSlider();
      }
      renderResultsTitle() {
        const e = {
            noQuery: this.config.translations.results_no_search,
            hasData: this.config.translations.results_true,
            noData: this.config.translations.results_false,
          }[
            this.query
              ? this.productData.length
                ? "hasData"
                : "noData"
              : "noQuery"
          ],
          t =
            this.query && this.productData.length
              ? this.config.translations.view_all
              : this.config.translations.shop_all,
          r = parseHTML(
            `<div class="results-title flex justify-space row--d2">\n          <span class="t-rm f-w600">${e}</span>\n          <a href="${
              this.query && this.productData.length
                ? `/search?q=${this.query}&view=ag`
                : this.config.settings.shop_all_url
            }" class="t-xxs f-w600 t-ucase t-ul flex align-center">${t}</a>\n        </div>`
          );
        this.agProducts.querySelector(".results-title")?.remove(),
          this.agProducts.appendChild(r);
      }
      buildKeenSlider() {
        this.resultSlider?.destroy(),
          this.waitForKeenSlider().then(() => {
            this.resultSlider = new KeenSlider(
              ".ag-products-slider",
              {
                loop: !1,
                slides: { perView: 2, spacing: 12 },
                breakpoints: {
                  "(min-width: 768px)": { slides: { perView: 3, spacing: 12 } },
                  "(min-width: 1024px)": { slides: { perView: 4 } },
                },
                created: () => {
                  this.classList.contains("hide") ||
                    setTimeout(() => {
                      this.adjustHeights(".ag-products .product-card__title");
                    }, 50);
                },
              },
              [KSnavigation]
            );
          });
      }
      openSearch() {
        this.hasBeenOpened ||
          ((this.hasBeenOpened = !0),
          (this.linksData = this.config.defaultLinks)),
          this.setAttribute("query", this.query),
          document.body.classList.add("search-open"),
          this.mask.classList.remove("hide"),
          this.classList.remove("hide"),
          this.buildKeenSlider(),
          this.agFormInput.focus();
      }
      closeSearch() {
        document.body.classList.remove("search-open"),
          this.mask.classList.add("hide"),
          this.classList.add("hide");
      }
      async performSearch(e) {
        const t = this.config.agConfig;
        this.previousProductResults = this.searchData?.products?.hits ?? [];
        const r = await this.agSearch.search({
          query: e || "empty",
          indexes: Object.keys(t.indices).reduce(
            (e, r) => (
              this.config.agConfig.indices[r] &&
                e.push({ indexName: `${t.prefix}${r}`, key: r }),
              e
            ),
            []
          ),
        });
        e || (this.defaultProducts = r.products.hits), (this.searchData = r);
      }
      adjustHeights(e) {
        const t = this.querySelectorAll(e),
          r = Array.from(t).reduce((e, t) => Math.max(e, t.offsetHeight), 0);
        t.forEach((e) => (e.style.height = `${r}px`));
      }
      async waitForKeenSlider() {
        return new Promise((e, t) => {
          const pingKS = () => {
            "undefined" != typeof KeenSlider ? e() : setTimeout(pingKS, 100);
          };
          pingKS();
        });
      }
      getVisibleHeight(e) {
        const t = e.getBoundingClientRect(),
          r = window.innerHeight;
        if (t.bottom < 0 || t.top > r) return 0;
        {
          const e = Math.max(t.top, 0);
          return Math.min(t.bottom, r) - e;
        }
      }
      arrayCompare(e, t) {
        return e.length === t.length && e.every((e, r) => e === t[r]);
      }
      mergeResults(e, t, r) {
        const a = e.reduce(
            (e, r) => (
              t.forEach((t) => {
                r[t] && (e = { ...e, ...r[t] });
              }),
              e
            ),
            {}
          ),
          s = e.filter((e) => !t.some((t) => t in e));
        return s.push({ [r]: a }), s;
      }
      updateTitles(e) {
        e.forEach((e) => {
          const t = Object.keys(e)[0];
          Object.entries(this.config.settings.titles).forEach(([r, a]) => {
            if (r === Object.keys(e)[0]) {
              const r = e[t];
              (e[a] = r), delete e[t];
            }
          });
        });
      }
    }
    customElements.define("algolia-search-header", AlgoliaSearchHeader),
      DomReadyPromise()
        .then(() => {
          let e = !1;
          document
            .querySelectorAll('[href="#account"], [account-modal]')
            .forEach((t) =>
              t.addEventListener("click", async (t) => {
                t.preventDefault(),
                  window.customer_logged_in
                    ? (window.location.href = "/account")
                    : (e ||
                        (await new Promise((t, r) => {
                          fetch("/account/login?view=ajax")
                            .then((e) => e.text())
                            .then((r) => {
                              (e = new ModalBox({
                                content: r,
                                settings: {
                                  contentClass: "bg-white",
                                  containerCloseButton: !0,
                                },
                              })),
                                e.subscribe(({ type: t }) => {
                                  if ("open:rendered" == t) {
                                    e.wrapper
                                      .querySelectorAll('[name="return_to"]')
                                      .forEach((e) => {
                                        e.value = `${window.location.pathname}${window.location.search}`;
                                      });
                                    let t = !1;
                                    const r =
                                        e.wrapper.querySelector(
                                          "#CustomerLoginForm"
                                        ),
                                      a = e.wrapper.querySelector(
                                        "#RecoverPasswordForm"
                                      );
                                    e.wrapper
                                      .querySelectorAll(
                                        ".js-password-reset-toggle"
                                      )
                                      .forEach((e) =>
                                        e.addEventListener("click", (e) => {
                                          e.preventDefault(),
                                            (t = !t),
                                            (r.style.display = t
                                              ? "none"
                                              : "block"),
                                            (a.style.display = t
                                              ? "block"
                                              : "none");
                                        })
                                      );
                                    const s =
                                        e.wrapper.querySelectorAll(
                                          "[data-tab]"
                                        ),
                                      i =
                                        e.wrapper.querySelector(
                                          ".js-login-form"
                                        ),
                                      n =
                                        e.wrapper.querySelector(
                                          ".js-register-form"
                                        );
                                    s.forEach((e) =>
                                      e.addEventListener("click", (t) => {
                                        t.preventDefault();
                                        const { tab: r } = e.dataset;
                                        (i.style.display =
                                          "login" == r ? "block" : "none"),
                                          (n.style.display =
                                            "register" == r ? "block" : "none"),
                                          s.forEach((t) => {
                                            t.classList.toggle(
                                              "selected",
                                              t == e
                                            );
                                          });
                                      })
                                    );
                                  }
                                }),
                                t();
                            })
                            .catch((e) => {
                              r();
                            });
                        })),
                      e.open());
              })
            );
        })
        .catch((e) => console.log(e));
  })();
  var a = self;
  for (var s in r) a[s] = r[s];
  r.__esModule && Object.defineProperty(a, "__esModule", { value: !0 });
})();
